import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/core/services/user.service';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';
import {Router, ActivatedRoute} from '@angular/router';
import { BaseService } from 'src/app/core/services/base.service';
import { Config } from 'src/app/config/constants';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import * as pay from '../../../../assets/external.js';
declare var pay: any;
@Component({
  selector: 'app-change-policy',
  templateUrl: './change-policy.component.html',
  styleUrls: ['./change-policy.component.scss'],
  providers: [DatePipe],
})


  export class ChangePolicyComponent implements OnInit {

    @BlockUI() blockUI: NgBlockUI;
    showSearchedPolicy:boolean=false;
    showPolicyDetails:boolean=false;
    showPolicySearch:boolean=true;
    showRefundPolicy:boolean=false;
    showAudtiLogs:boolean=false;
    selectedPolicyId:any;
    editcreditCardDetails: any=[];
    cardType:any
    agentId: any;
  sslCardNumber
  sslCardShortDescription:any
  sslCardType:any
  sslCvv2Response:any
  sslExpDate:any
  sslTransactionType:any
  minDate = new Date();
  startDate: any;
  minDate1 = new Date()
  minDateArrival:any;
  showarrivalDateInCanadaPopup:boolean=false;
  createdDate:any;
  Amount2: any;
  Amount3: any;
  Amount4: any;
  Amount5: any;
  cardType1: any;
  cardType2: any;
  cardType3: any;
  cardType4: any;
  cardType5: any;
  cvv2: any;
  cvv3: any;
  cvv4: any;
  cvv5: any;
  CardNumber2: any;
  CardNumber3: any;
  CardNumber4: any;
  CardNumber5: any;
  cardexpdate2: any;
  cardexpdate3: any;
  cardexpdate4: any;
  cardexpdate5: any;
    AmounttoPay: any;
    travellerInfoToSend: any=[];
    Amounttotal: any;
    travellerInfoDetailsToSend: any=[];
    language: any;
    insuredinfoArray: any=[];
    paymentInfo: boolean;
    transactionResponseArray: any;
    Refund: any="Payment Amount";
    FinalizeBtnName:any="Finalize Payment";
    responseID: any;
    salesType: any;
    policypremium: any;
    fulfillmentArray: any=[];
    CardNumber1: any;
    cardexpdate1: any;
    cvv1: any;
    showCardNo1:boolean=false;
    showCardNo2:boolean=false;
    showCardNo3:boolean=false;
    showCardNo4:boolean=false;
    showCardNo5:boolean=false;
    showCVV1:boolean=false;
    showCVV2:boolean=false;
    showCVV3:boolean=false;
    showCVV4:boolean=false;
    showCVV5:boolean=false;
    showexp1:boolean=false;
    showexp2:boolean=false;
    showexp3:boolean=false;
    showexp4:boolean=false;
    showexp5:boolean=false;
    paymentTokenNew: any;
    hideQuotePurchase: any;
    isChange: boolean=false;
  policypaymentdetailsArray: any[];
  ArrivalDateFlagValid: boolean=false;
  primaryAddress1c: any;
  purchaserAddress1c: any;
  showcheckbox: boolean=false;
  maxDatestart = new Date(new Date().setDate(new Date().getDate() +1095))
  purchaserCountryName: any;
  checkOVRInAgencyCode: any;
  sslToken: any=null;
  isPayment: boolean=false;
  ccNumber: any;
agentIdActive: string;
  leadsId: any;
  leadStatus: any;
    constructor(public userservice: UserService,private datePipe: DatePipe,private base: BaseService,private config:Config,public user: UserService,private router: Router) { }
  
    ngOnInit() {
      this.leadsId=sessionStorage.getItem('leadId');
      this.policyId=localStorage.getItem('tlSalesAdminPolicyAdmin');
      this.hideQuotePurchase=sessionStorage.getItem('hideQuotePurchase');
      this.checkOVRInAgencyCode=sessionStorage.getItem('checkOVRInAgencyCode');
      this.getPolicyByIdSalesAdmin();
      this.addFirstValueTraveller();
      this.minDate.setHours(0, 0, 0, 0);
      this.minDate1.setHours(0, 0, 0, 0);
      // this.minDateArrival.setHours(0, 0, 0, 0);
      // this.minDateArrival.setHours(0, 0, 0, 0);
      this.agentId=sessionStorage.getItem('agentIdSalesPortal');
      this.getLeadAgentsCodes();
      this.insuredPerson();
      this.getcountryListing();
      this.getAllProvinces();
      this.getAllLanguages();
      this.getDashboard();
      let morningSlotDate = new Date();
      this.createdDate = this.datePipe.transform(morningSlotDate, "MM/dd/yyyy");
    }
    applicationEndDate ="";
    applicationStartDate ="";
    creditCardNumber ="";
    departureEndDate ="";
    departureStartDate ="";
    effectiveEndDate ="";
    effectiveStartDate ="";
    firstName ="";
    lastName ="";
    policyNumber ="";
    agencyCode="";
    onClickPolicySearch(){
      this.showSearchedPolicy = true;
      if(!this.policyNumber && !this.lastName && !this.firstName && !this.effectiveStartDate
        && !this.departureStartDate && !this.departureEndDate && !this.creditCardNumber && !this.applicationStartDate
        && !this.applicationEndDate){
          this.getAllPolicyForSalesAdmin();
        }else{
          this.searchFilterPolicy();
        }
    }
    policyId: any;
    policyInsureds=[];
    getPolicyData=[];
    selectedPlans=[];
    policyQuestionAnswers=[];
    transactionDetails=[];
    policyNumber1: any;
    txnId: any;
    refundPolicyReason: any;
    onClickPolicyNumber(id,number){
      this.showPolicyDetails=true;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
      this.showPolicySearch=false;
      this.selectedPolicyId=this.policyId;
      this.policyNumber = number;
      this.userservice.getPolicyById1(this.policyId).pipe()
      .subscribe(
          data => {
      this.policyInsureds = data.data.policyInsureds;
      this.selectedPlans = data.data.plans;
      this.policyQuestionAnswers = data.data.policyQuestionAnswers;
      this.getPolicyData.push(data.data);
      this.transactionDetails = data.data.transactions;
      if(data.data.transactions != null ){
        this.txnId = data.data.transactions[0].transactionPaymentDetails[0].sslTxnId
      }
          },error=>{},()=>{});
       this.getPolicyByIdSalesAdmin();
    }
    backToPolicySearch(){
      // this.showSearchedPolicy=true;
      // this.showPolicyDetails=false;
      // this.showPolicySearch=true;
      // this.showRefundPolicy=false;
      // this.showAudtiLogs=false;
      // this.showChangePolicy=false;
      // this.showEditBillingInformation=false;
      this.router.navigateByUrl('/dashboard/policy-search');
    }
    onClickRefundPolicy(){
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=true;
      this.showAudtiLogs=false;
    }
  
    showRemove:boolean=false;
    insuredCount=1;
    numberOFInsured:any=0;
    incNumberOfInsured(){
      // if(this.numberOFInsured !=9){
      //   this.numberOFInsured++;
      // }
      if(this.insuredCount !=9){
        this.insuredCount++
        this.numberOFInsured =this.insuredCount;
        this.addFirstValueTraveller();
        if(this.insuredCount>1){
          this.showRemove=true;
        }else{
          this.showRemove=false;
        }
      }
    }
    minusNumberOfInsured(){
      // if(this.numberOFInsured < 10 && this.numberOFInsured > 0){
      //   this.numberOFInsured--;
      // }
      if(this.insuredCount < 10 && this.insuredCount > 1){
        this.numberOFInsured = this.insuredCount
        this.insuredCount--
        this.travellerInfo.splice(this.insuredCount, 1);
        if(this.insuredCount >1){
          this.showRemove=true;
         }else{
           this.showRemove=false; 
         }
      }
    }
  
    minusNumberOfInsuredShort(i){
      if(this.insuredCount < 10 && this.insuredCount > 0){
        this.numberOFInsured--;
        this.insuredCount--
        this.travellerInfo.splice(i, 1);
        if(this.insuredCount>1){
          this.showRemove=true;
         }else{
           this.showRemove=false; 
         }
      }
    }
   
    // minDate = new Date();
    // minDate1 = new Date()
    // minDateArrival= new Date();
    startDateFlag: boolean=false;
    // startDate: any;
    chkDate:any
  chkDate2:any
  startDateFlagValid:boolean=false
  expiryDateFlagValid:boolean=false
  
    callStartDateFunction(event){
      if(this.startDate!=null){
      console.log("Start date!!",this.startDate);
      if(this.startDate._d){
      this.startDate = this.startDate._d;
      }
    if(this.startDate){
   
      this.startDateFlag=false;
      this.startDateFlagValid=false
      // this.minDate=this.startDate;
      this.minDateArrival=this.startDate;
     
      var chkDate1 = this.datePipe.transform(this.startDate, "yyyy-MM-dd");
      this.chkDate = new Date();
     this.chkDate=this.datePipe.transform(this.chkDate, "yyyy-MM-dd");
     var maxDate=this.datePipe.transform(this.maxDatestart, "yyyy-MM-dd");
     console.log(this.chkDate)
     console.log(chkDate1)
    if(chkDate1>maxDate){
    this.startDateFlagValid=true
       
    }
    
     else if(chkDate1<this.chkDate){
       this.startDateFlagValid=true
       
     }
     else{
       this.startDateFlagValid=false
     }
      for(let i=0;i<this.travellerInfo.length;i++){
          this.travellerInfo[i].arrivalDateOfCanada=null;
          this.travellerInfo[i].waitPeroid=null;
        
        
      }
    if(this.expiryDate){
  
        const dateTwo = new Date(new Date(this.startDate).setDate(this.startDate.getDate() + this.calculatedDays));
        this.expiryDate=dateTwo;
        this.minDateArrival = new Date(this.startDate)
      }
      if(this.calculatedDays){
        this.callCalculatedDaysFunction()
      }
      }
      for(let i=0;i<this.travellerInfo.length;i++){
        if(!this.startDate){
          this.travellerInfo[i].arrivalDateOfCanada=null;
          this.travellerInfo[i].waitPeroid=null;
        }
      }
    }
    else{
      this.startDateFlagValid=true
       
    }
      
    }
  
    errorNegative:boolean=false;
    expiryDateFlag: boolean=false;
    expiryDate: any;
    calculatedDays: any=0;
    callExpiryDateFunction(event){
      // this.startDateFlag=false;
      if(this.expiryDate!=null){
      if(this.expiryDate._d){
      this.expiryDate = this.expiryDate._d;
    }
      console.log("Expiry Date!!",this.expiryDate);
      // if(this.calculatedDays<0){
      //   this.errorNegative=true;
      // }else{
         this.errorNegative=false;
      if(this.expiryDate){
//         this.startDate=new Date(this.startDate)
//         this.expiryDate=new Date(this.expiryDate)
// // this.startDate=( new Date( this.startDate.getTime() - this.startDate.getTimezoneOffset() * -60000 )  );
// // this.expiryDate=( new Date( this.expiryDate.getTime() - this.expiryDate.getTimezoneOffset() * -60000 )  );
// this.startDate = new Date(this.startDate.getUTCFullYear(), this.startDate.getUTCMonth(), this.startDate.getUTCDate());
// this.expiryDate = new Date(this.expiryDate.getUTCFullYear(), this.expiryDate.getUTCMonth(), this.expiryDate.getUTCDate());
      var Time = this.expiryDate.getTime() - this.startDate.getTime(); 
      var Days = Time / (1000 * 60 * 60 *24); //Diference in Days
      let a = Math.round(Days)
      this.calculatedDays=a+1;
      this.expiryDateFlag=false;
      this.expiryDateFlagValid=false
      var chkDate2 = this.datePipe.transform(this.expiryDate, "yyyy-MM-dd");
     this.chkDate2 = new Date();
    this.chkDate2=this.datePipe.transform(this.chkDate, "yyyy-MM-dd");
    console.log(this.chkDate2)
    console.log(chkDate2)
    if(chkDate2<this.chkDate2){
      this.expiryDateFlagValid=true
      
    }
    else{
      this.expiryDateFlagValid=false
    }
      var chkDate2 = this.datePipe.transform(this.expiryDate, "yyyy-MM-dd");
     this.chkDate2 = new Date();
    this.chkDate2=this.datePipe.transform(this.chkDate, "yyyy-MM-dd");
    console.log(this.chkDate2)
    console.log(chkDate2)
    if(chkDate2<this.chkDate2){
      this.expiryDateFlagValid=true
      
    }
    else{
      this.expiryDateFlagValid=false
    }
      if(this.calculatedDays<0){
        this.errorNegative=true;
        }
      if(this.calculatedDays>365 ){
        this.exceedNoOfDays = true;
      }else{
        this.exceedNoOfDays = false;
      }
      if(this.calculatedDays<14 && this.calculatedDays>-1){
        this.exceedNoOfDays1=true
      }else{
        this.exceedNoOfDays1 = false;
      }
      }
    }
    else{
      this.expiryDateFlagValid=true
    }
    }
  
  
  exceedNoOfDays:boolean=false
  exceedNoOfDays1:boolean=false
  errorFlagNoDays:boolean=false
    callCalculatedDaysFunction(){
      // if(this.calculatedDays<0){
      //   this.errorNegative=true;
      // }else{
      //   this.errorNegative=false;
      // if(this.startDate){
      // const dateTwo = new Date(new Date(this.startDate).setDate(this.startDate.getDate() + parseInt(this.calculatedDays)));
      // this.expiryDate=dateTwo;
      // }else{
      //   window.alert("Need valid start date before adding no of days.")  
      // }
      // }
      if(this.calculatedDays<14 && this.calculatedDays>-1){
        this.exceedNoOfDays1=true
      }else{
        this.exceedNoOfDays1 = false;
      }
    if(this.calculatedDays>365){
      this.exceedNoOfDays = true;
    }else{
      this.exceedNoOfDays=false
      if(this.calculatedDays<0){
        this.errorNegative=true;
        }else{
          this.errorNegative=false;
          if(this.startDate){
            // this.startDate=new setUTCDate(this.startDate)
          //  this.startDate = new Date(this.startDate);
// add a day
//  this.startDate.setUTCDate(this.startDate.getUTCDate() + 1);
// this.startDate = new Date(this.startDate.getUTCFullYear(), this.startDate.getUTCMonth(), this.startDate.getUTCDate());
                if(this.calculatedDays!=0){
                    const dateTwo = new Date(new Date(this.startDate).setDate(this.startDate.getDate() + parseInt(this.calculatedDays)-1));
                    this.expiryDate=dateTwo;
                    this.expiryDateFlag=false
                    this.expiryDateFlagValid=false
                 }
                 else{
                    const dateTwo = new Date(new Date(this.startDate).setDate(this.startDate.getDate() + parseInt(this.calculatedDays)));
                    this.expiryDate=dateTwo;
                    this.expiryDateFlag=false
                    this.expiryDateFlagValid=false
                 }
           
            }else{
              this.errorFlagNoDays=true;
              // window.alert("Need valid start date before adding no of days.")  
            }
        }
    }
    }
    
  dobFlag: boolean = false;
  ageErrorCross: boolean=false;
  callDateOfBirth(event){
  //   for(let i=0;i<this.travellerInfo.length;i++){
  //     var timeDiff = Math.abs(Date.now() - this.travellerInfo[i].dateOfBirth.getTime());
  //     var ageCalculate = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
  //     this.travellerInfo[i].age=ageCalculate;
  //     if(this.travellerInfo[i].age > 69){
  //       this.ageErrorCross = true;
  //     }else{
  //       this.ageErrorCross = false;
  //     }
  //     this.dobFlag=false;
  //   }
  //   for(let i=0;i<this.travellerInfo.length;i++){
  //     var timeDiff = Math.abs(Date.now() - this.travellerInfo[i].dateOfBirth.getTime()+1);
  //     var ageCalculate = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
  //     this.travellerInfo[i].age=ageCalculate;
  //     this.dobFlag=false;
  //     let startDate: string = this.travellerInfo[i].dateOfBirth;
  // let date1: Date = new Date();
  // let date2: Date = new Date(startDate);
  // let timeInMilisec: number = date1.getTime() - date2.getTime();
  // let daysBetweenDates: number = Math.ceil(timeInMilisec / (1000 * 60 * 60 * 24));
  // console.log(daysBetweenDates)
  //     if(this.travellerInfo[i].age > 69 || daysBetweenDates <31){
  //       // this.firstFormGroup.controls.itemRows.controls[index].ageErrorCross= true;
  //        this.ageErrorCross = true;
  //     }else{
  //       // this.firstFormGroup.controls.itemRows.controls[index].ageErrorCross= false;
  //        this.ageErrorCross = false;
  //     }
  //     }
  
  this.ageErrorCross=false;
  for(let i=0;i<this.travellerInfo.length;i++){
    if(this.travellerInfo[i].dateOfBirth!=null){
    if(this.travellerInfo[i].dateOfBirth._d){
    this.travellerInfo[i].dateOfBirth = this.travellerInfo[i].dateOfBirth._d;
  }
    this.travellerInfo[i].dateOfBirth = new Date(this.travellerInfo[i].dateOfBirth);
  var timeDiff = Math.abs(Date.now() - this.travellerInfo[i].dateOfBirth.getTime()+1);
  var ageCalculate = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
  this.travellerInfo[i].age=ageCalculate;
  // this.travellerInfo[i].dobFlag=false;
  let startDate: string = this.travellerInfo[i].dateOfBirth;
  let date1: Date = new Date();
  let date2: Date = new Date(startDate);
  let timeInMilisec: number = date1.getTime()+1 - date2.getTime()+1;
  let daysBetweenDates: number = Math.ceil(timeInMilisec / (1000 * 60 * 60 * 24));
  console.log(daysBetweenDates)
  if(this.travellerInfo[i].age > 69 || daysBetweenDates <31){
    this.travellerInfo[i].ageErrorCross=true
    this.travellerInfo[i].dobFlag=true;
    this.ageErrorCross=true;
  }else{
    this.travellerInfo[i].ageErrorCross=false
    this.travellerInfo[i].dobFlag=false;
    
  }
}
  else{
    this.travellerInfo[i].dobFlag=true;
  }
  }
  
    }
  innerPop: boolean=false;
  selectedQuestionAns1: any;
  currentIndex: any=0;
  arrivalDateCanadaFlag: boolean=false;
  // callArriveCanadaDate(event){
  //   if(this.startDate){
  //   for(let i=0;i<this.travellerInfo.length;i++){
  //     var Time = this.startDate.getTime() - this.travellerInfo[i].arrivalDateOfCanada.getTime(); 
  //     var Days = Time / (1000 * 3600 * 24); //Diference in Days
  //     // if(Days>=1 && Days <=30){
  //     if(Days>=1){
  //       // this.showarrivalDateInCanadaPopup=true;
  //       // item.waitPeroid
  //       this.travellerInfo[i].waitPeroid="48 hours for a sickness.";
  //       this.currentIndex = i
  //     }else if(Days<1){
  //       // this.showarrivalDateInCanadaPopup=true;
  //       // item.waitPeroid
  //       this.travellerInfo[i].waitPeroid="None";
  //       this.currentIndex = i
  //     }
  //     else{
  //       this.travellerInfo[i].waitPeroid="None";
  //       this.showarrivalDateInCanadaPopup=false;
  //       this.currentIndex = i
  //     }
  //   }
  //   this.arrivalDateCanadaFlag=false;
  // }else{
  // window.alert("Need valid expiry/start date to calculate the wait period of your policy.")
  //   for(let i=0;i<this.travellerInfo.length;i++){
  //       this.travellerInfo[i].arrivalDateOfCanada=null;
  //     }
  // }
  // }
  callArriveCanadaDate(event,index){
  //   if(this.startDate){
  //   for(let i=0;i<this.travellerInfo.length;i++){
  //     var Time = this.startDate.getTime() - this.travellerInfo[i].arrivalDateOfCanada.getTime(); 
  //     var Days = Time / (1000 * 3600 * 24); //Diference in Days
  //     // if(Days>=1 && Days <=30){
  //     if(Days>=1){
  //       // this.showarrivalDateInCanadaPopup=true;
  //       // item.waitPeroid
  //       this.travellerInfo[i].waitPeroid="48 hours for a sickness.";
  //       this.currentIndex = i
  //     }else if(Days<1){
  //       // this.showarrivalDateInCanadaPopup=true;
  //       // item.waitPeroid
  //       this.travellerInfo[i].waitPeroid="None";
  //       this.currentIndex = i
  //     }
  //     else{
  //       this.travellerInfo[i].waitPeroid="None";
  //       this.showarrivalDateInCanadaPopup=false;
  //       this.currentIndex = i
  //     }
  //   }
  //   this.arrivalDateCanadaFlag=false;
  // }else{
  //   window.alert("Need valid expiry/start date to calculate the wait period of your policy.")
  //   for(let i=0;i<this.travellerInfo.length;i++){
  //       this.travellerInfo[i].arrivalDateOfCanada=null;
  //     }
  // }
  if(this.startDate){
    this.startDate=new Date(this.startDate)
    for(let i=0;i<this.travellerInfo.length;i++){
      if(this.travellerInfo[index].arrivalDateOfCanada!=null){
      if(this.travellerInfo[index].arrivalDateOfCanada._d){
      this.travellerInfo[index].arrivalDateOfCanada = this.travellerInfo[index].arrivalDateOfCanada._d;
      }
      console.log("Arrivaldateincanada!!",this.travellerInfo[index].arrivalDateOfCanada);
      if(this.travellerInfo[index].arrivalDateOfCanada){
        this.travellerInfo[index].arrivalDateOfCanada= new Date(this.travellerInfo[index].arrivalDateOfCanada);
        // this.startDate=new Date(this.startDate)
        // this.startDate = new Date(this.startDate.getUTCFullYear(), this.startDate.getUTCMonth(), this.startDate.getUTCDate());
      var Time = this.startDate.getTime()+1 - this.travellerInfo[index].arrivalDateOfCanada.getTime()+1; 
      var Days = Time / (1000 * 3600 * 24); //Diference in Days
      // if(Days>=1 && Days <=30){
        var chkDate1 = this.datePipe.transform(this.travellerInfo[index].arrivalDateOfCanada, "yyyy-MM-dd");
  this.chkDate = new Date();
 this.chkDate=this.datePipe.transform(this.startDate, "yyyy-MM-dd");
 console.log(this.chkDate)
 console.log(chkDate1)
 if(chkDate1>this.chkDate){
      
  this.travellerInfo[index].ArrivalDateFlagValid=true
  this.travellerInfo[index].arrivalDateCanadaFlag = false;
  this.ArrivalDateFlagValid=true
 }
 else{
  this.ArrivalDateFlagValid=false
  this.travellerInfo[index].ArrivalDateFlagValid=false
  this.travellerInfo[index].arrivalDateCanadaFlag = false;
 }
 
      if(Days>=1){
         this.showarrivalDateInCanadaPopup=true;
        // item.waitPeroid
        // this.travellerInfo[index].waitPeroid="48 Hours - Sickness";
        this.currentIndex = index
      }else{
        // this.showarrivalDateInCanadaPopup=true;
        // item.waitPeroid
        this.travellerInfo[index].waitPeroid="None";
        this.currentIndex = index
      }
      
      this.travellerInfo[index].arrivalDateCanadaFlag=false;
    }
    else{
      this.travellerInfo[index].waitPeroid=null
    }
  }else{
    this.travellerInfo[index].ArrivalDateFlagValid=true
    this.travellerInfo[index].arrivalDateCanadaFlag = false;
  this.ArrivalDateFlagValid=true
  }
    }
    
  }else{
    window.alert("Need valid expiry/start date to calculate the wait period of your policy.")
    for(let i=0;i<this.travellerInfo.length;i++){
        this.travellerInfo[i].arrivalDateOfCanada=null;
        this.travellerInfo[index].waitPeroid=null
      }
  }
  
  }
    travellerInfo:any[]=[];
    addFirstValueTraveller(){
      
      var obj={};
      obj["dateOfBirth"]="";
      obj["age"]="";
      obj["arrivalDateOfCanada"]="";
      obj["waitPeroid"]="";
      obj["id"]=0;
      this.travellerInfo.push(obj);
      this.numberOFInsured=1;
    }
    showOkButton: boolean=false;
    onClickQuestion1(data){
      if(data == "Yes"){
        // this.innerPop=true;
        this.showOkButton=true
        this.travellerInfo[this.currentIndex].waitPeroid="None";
        }else{
          this.showOkButton=true
          // for(let i=0;i<this.travellerInfo.length;i++){
            if(this.travellerInfo[this.currentIndex].arrivalDateOfCanada._d){
              this.travellerInfo[this.currentIndex].arrivalDateOfCanada = this.travellerInfo[this.currentIndex].arrivalDateOfCanada._d;
            }
            var Time = this.startDate.getTime() - this.travellerInfo[this.currentIndex].arrivalDateOfCanada.getTime(); 
            var Days = Time / (1000 * 3600 * 24); //Diference in Days 
            this.travellerInfo[this.currentIndex].waitPeroid="48 Hours - Sickness";
            // if(Days>=1 && Days <=30  && this.currentIndex == i){
            //   this.showarrivalDateInCanadaPopup=true;
            //   this.travellerInfo[i].waitPeroid="48 hours for a sickness. 24 hours for an Injury";
            // }else if(Days>=30  && this.currentIndex == i){
            //   this.showarrivalDateInCanadaPopup=true;
            //   this.travellerInfo[i].waitPeroid="7 days for a Sickness, 24 hours for an injury";
            // }
          // }
        // this.innerPop=false;
        }
      }
  
  
      onClickQuestion2(data){
        if(data == "Yes"){
          for(let i=0;i<this.travellerInfo.length;i++){
            var Time = this.startDate.getTime() - this.travellerInfo[i].arrivalDateOfCanada.getTime(); 
            var Days = Time / (1000 * 3600 * 24); //Diference in Days 
            if(Days>=1 && Days <=30  && this.currentIndex == i){
              this.showarrivalDateInCanadaPopup=true;
              this.travellerInfo[i].waitPeroid="None";
            }else if(Days>=30  && this.currentIndex == i){
              this.showarrivalDateInCanadaPopup=true;
              this.travellerInfo[i].waitPeroid="None";
            }
           
          }
          }else{
            for(let i=0;i<this.travellerInfo.length;i++){
              var Time = this.startDate.getTime() - this.travellerInfo[i].arrivalDateOfCanada.getTime(); 
              var Days = Time / (1000 * 3600 * 24); //Diference in Days 
              if(Days>=1 && Days <=30 && this.currentIndex == i){
                this.showarrivalDateInCanadaPopup=true;
                this.travellerInfo[i].waitPeroid="48 hours for a sickness. 24 hours for an Injury";
              }else if(Days>=30  && this.currentIndex == i){
                this.showarrivalDateInCanadaPopup=true;
                this.travellerInfo[i].waitPeroid="7 days for a Sickness, 24 hours for an injury";
              }
             
            }    }
      }
  
      selectedQuestionAns2: any;
  modalCloseQuestion(){
    this.showOkButton=false
    this.showarrivalDateInCanadaPopup=false;
    this.selectedQuestionAns1=undefined;
    this.selectedQuestionAns2=undefined;  
    this.innerPop=false;
  }
  
  selectedQuestionprovince1: any;
  selectedQuestionlanguages1: any;
  planQuoteResponses=[];
  startDateShow=""
  expiryDateShow: any;
  resdentShowShow: any;
  daysToshow: any;
  travellerInformation=[];
  qestionInfoArray=[];
  
  postCallStep1(){
    
    var flag=true;
    if(!this.expiryDate){this.expiryDateFlag=true;flag=false}else{this.expiryDateFlag=false;this.expiryDateFlagValid=false}
    if(!this.startDate){this.startDateFlag=true;flag=false}else{this.startDateFlag=false;this.startDateFlagValid=false}
    if(!this.travellerInfo[0].arrivalDateOfCanada){this.arrivalDateCanadaFlag=true;flag=false}else{this.arrivalDateCanadaFlag=false}
    if(!this.travellerInfo[0].dateOfBirth){this.dobFlag=true;flag=false}else{this.dobFlag=false}
    if(!this.ageErrorCross){flag=false}else{}
     this.expiryDate = this.datePipe.transform(this.expiryDate, "yyyy-MM-dd");
     this.startDate = this.datePipe.transform(this.startDate, "yyyy-MM-dd");
  
    // //  var chkDate1 = this.datePipe.transform(this.startDate, "yyyy-MM-dd");
    // //  this.chkDate = new Date();
    // // this.chkDate=this.datePipe.transform(this.chkDate, "yyyy-MM-dd");
    // // console.log(this.chkDate)
    // // console.log(chkDate1)
    // // if(chkDate1<this.chkDate){
    // //   this.startDateFlagValid=true
    // //   flag=false
    // // }
    // // else{
    // //   this.startDateFlagValid=false
    // // }
    
    // //  var chkDate2 = this.datePipe.transform(this.expiryDate, "yyyy-MM-dd");
    // //  this.chkDate2 = new Date();
    // // this.chkDate2=this.datePipe.transform(this.chkDate, "yyyy-MM-dd");
    // // console.log(this.chkDate2)
    // // console.log(chkDate2)
    // // if(chkDate2<this.chkDate2){
    // //   this.expiryDateFlagValid=true
    // //   flag=false
    // // }
    // // else{
    // //   this.expiryDateFlagValid=false
    // // }
    //  for(let i=0;i<this.travellerInfo.length;i++){
    //   this.travellerInfo[i].arrivalDateOfCanada = this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd");
    //   this.travellerInfo[i].dateOfBirth = this.datePipe.transform(this.travellerInfo[i].dateOfBirth, "yyyy-MM-dd");
    //  }
  
      if (flag == true) {
        for(let i=0;i<this.travellerInfo.length;i++){
          var obj={}    
        
          obj["age"]= this.travellerInfo[i].age;
          obj["arrivalDateInCanada"]= this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd");
          obj["arrivalDateOfCanada"]= this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd");
          obj["country"]=  this.travellerInfo[i].homeCountry;
          obj["dateOfBirth"]= this.travellerInfo[i].dateOfBirth;
          obj["dayTimePhone"]= ""
          obj["deductableOptionId"]= ""
          obj["departureCity"]= this.travellerInfo[i].homeCountry;
          obj["eligable"]= "true"
          obj["emailAddress"]= ""
          obj["firstName"]= this.travellerInfo[i].firstName;
          obj["insitute"]= this.travellerInfo[i].insitute
          obj["language"]= this.language
          obj["lastName"]= this.travellerInfo[i].lastName;
          obj["premium"]= 0;
          obj["questionsansers"]=[]
          obj["tripCost"]= 0
          obj["insuredId"]=this.travellerInfo[i].id
          obj["waitPeroid"]= this.travellerInfo[i].waitPeroid;
          this.travellerInfoDetailsToSend.push(obj)
          }
        const request = 
        {
      "agentId": this.agentId,
      "declaration": true,
      "deductableOptions": [
        {
          "amount": 0,
          "createdAt": "",
          "createdBy": "",
          "id": 0,
          "lastModifiedBy": "",
          "option": "",
          "reduceAmount": 0,
          "updatedAt": ""
        }
      ],
      "language": this.selectedQuestionlanguages1,
      "noOfDays": this.calculatedDays,
      "optionalInformation": {
        "agentNote": this.agentNote,
        "beneficiary": this.beneficiary,
        "comment": this.comment
      },
      "paymentInformation": {
        "amount": 0,
        "cardNumber": "",
        "cardType": "",
        "cvv": "",
        "expiryDate": ""
      },
      "primaryAddress": {
        "address1": this.primaryAddress1,
        "address2": this.primaryAddress2,
        "city": this.primaryCity,
        "postalCode": this.primaryPostalCode,
        "province":this.primaryProvince
      },
      "isS": true,
      "questionsansers": [
     
      ],
      "residentOf": this.purchaseProvince,
      "returnDate": this.expiryDate,
      "secondaryAddress": {
        "address1": "",
        "address2": "",
        "city": "",
        "postalCode": "",
        "province":""
      },
      "selectedPlan": {},
      "startDate": this.startDate,
      "travellerInformation": this.travellerInfo,
      "travelllerDetails": this.travellerInfoDetailsToSend,
      "visitorsToCanada": "yes",
      "purchaserInformation":{
        "country": "",
        "emailAddress": this.purchaseEmail,
        "firstName": this.purchaserFirstName,
        "language":"",
        "lastName": this.purchaserLastName,
        "phoneNumber1": this.purchasePhone1,
        "phoneNumber2": this.purchasePhone2,
        "postalCode": this.purchasePostalCode,
        "province": this.purchaseProvince,
        "purchaserAddress": {
          "address1": this.purchaserAddress1,
          "address2": this.purchaserAddress2,
          "city": this.purchaseCity,
          "postalCode": this.purchasePostalCode
      }}
         }
        this.base.callPostService(this.config.postApistep1, request).subscribe((data: any) => {
        this.onClickToShowPlanInfo();
        this.planQuoteResponses = data.data.planQuoteResponses;
        this.startDateShow = data.data.salesRequest.startDate;
        this.expiryDateShow=data.data.salesRequest.returnDate;
        this.resdentShowShow=data.data.salesRequest.residentOf;
        this.daysToshow = this.calculatedDays;
        this.travellerInformation = data.data.salesRequest.travellerInformation;
        this.qestionInfoArray = data.data.questions;
        this.qestionInfoArrayShow.push(this.qestionInfoArray[0]);
           }, error => {
      
        }, () => { });
    }}
    qestionInfoArrayShow=[];
  
    onClickToShowPlanInfo1(){
      
      for(let k=0;k<this.travellerInfo.length;k++){
        if(this.travellerInfo[k].arrivalDateOfCanada =="" || this.travellerInfo[k].arrivalDateOfCanada==null){
          this.arrivalDateCanadaFlag=true
          this.travellerInfo[k].arrivalDateCanadaFlag=true
          this.travellerInfo[k].ArrivalDateFlagValid = false;
          // this.travellerInfo[k].arrivalDateOfCanada=""
        }
        else{
          this.arrivalDateCanadaFlag=false
          this.travellerInfo[k].arrivalDateCanadaFlag=false
          this.travellerInfo[k].ArrivalDateFlagValid = false;
          // this.travellerInfo[k].arrivalDateOfCanada=""
        }
        // this.travellerInfo[k].dateOfBirth = this.datePipe.transform(this.travellerInfo[k].dateOfBirth, "yyyy-MM-dd");
        if(this.travellerInfo[k].dateOfBirth ==""  || this.travellerInfo[k].dateOfBirth==null){
          this.dobFlag=true;
          this.travellerInfo[k].dobFlag=true
        }
        else{
          this.dobFlag=false;
          this.travellerInfo[k].dobFlag=false
        }
      }
  //     if(!this.expiryDate){this.expiryDateFlag=true}else{this.expiryDateFlag=false;this.expiryDateFlagValid=false}
  // if(!this.startDate){this.startDateFlag=true}else{this.startDateFlag=false;this.startDateFlagValid=false}
  // if(!this.travellerInfo[0].arrivalDateOfCanada){this.arrivalDateCanadaFlag=true}else{this.arrivalDateCanadaFlag=false}
  // if(!this.travellerInfo[0].dateOfBirth){this.dobFlag=true}else{this.dobFlag=false}
    }
    onClickToShowPlanInfo(){
      window.scrollTo(0,0);
    var flag=true;
    if(!this.expiryDate){this.expiryDateFlag=true;flag=false}else{this.expiryDateFlag=false;this.expiryDateFlagValid=false}
    if(!this.startDate){this.startDateFlag=true;flag=false}else{this.startDateFlag=false;this.startDateFlagValid=false}
    // if(!this.travellerInfo[0].arrivalDateOfCanada){this.arrivalDateCanadaFlag=true;flag=false}else{this.arrivalDateCanadaFlag=false;flag=true}
    // if(!this.travellerInfo[0].dateOfBirth){this.dobFlag=true;flag=false}else{this.dobFlag=false;flag=true}
    for(let k=0;k<this.travellerInfo.length;k++){
      if(this.travellerInfo[k].arrivalDateOfCanada =="" || this.travellerInfo[k].arrivalDateOfCanada==null){
        this.arrivalDateCanadaFlag=true;flag=false
        this.travellerInfo[k].arrivalDateCanadaFlag=true
        this.travellerInfo[k].ArrivalDateFlagValid = false;
        // this.travellerInfo[k].arrivalDateOfCanada=""
      }
      else{
        this.arrivalDateCanadaFlag=false;
        this.travellerInfo[k].arrivalDateCanadaFlag=false
        this.travellerInfo[k].ArrivalDateFlagValid = false;
        // this.travellerInfo[k].arrivalDateOfCanada=""
      }
      // this.travellerInfo[k].dateOfBirth = this.datePipe.transform(this.travellerInfo[k].dateOfBirth, "yyyy-MM-dd");
      if(this.travellerInfo[k].dateOfBirth =="" || this.travellerInfo[k].dateOfBirth==null){
        this.dobFlag=true;flag=false
        this.travellerInfo[k].dobFlag=true
      }
      else{
        this.dobFlag=false;
        this.travellerInfo[k].dobFlag=false
      }
      if(this.travellerInfo[k].tripCost!==null){
      var tripcost = this.travellerInfo[k].tripCost;
      while(tripcost.charAt(0) === '$')
         {
          tripcost = tripcost.substring(1);          
         }
         
         tripcost=tripcost.replace (/,/g, "");
         this.travellerInfo[k].tripCost=tripcost
        }
    }
    
     this.expiryDate = this.datePipe.transform(this.expiryDate, "yyyy-MM-dd");
     this.startDate = this.datePipe.transform(this.startDate, "yyyy-MM-dd");
     
    // //  var chkDate1 = this.datePipe.transform(this.startDate, "yyyy-MM-dd");
    // //  this.chkDate = new Date();
    // // this.chkDate=this.datePipe.transform(this.chkDate, "yyyy-MM-dd");
    // // console.log(this.chkDate)
    // // console.log(chkDate1)
    // // if(chkDate1<this.chkDate){
    // //   this.startDateFlagValid=true
    // //   flag=false
    // // }
    // // else{
    // //   this.startDateFlagValid=false
    // // }
    
    // //  var chkDate2 = this.datePipe.transform(this.expiryDate, "yyyy-MM-dd");
    // //  this.chkDate2 = new Date();
    // // this.chkDate2=this.datePipe.transform(this.chkDate, "yyyy-MM-dd");
    // // console.log(this.chkDate2)
    // // console.log(chkDate2)
    // // if(chkDate2<this.chkDate2){
    // //   this.expiryDateFlagValid=true
    // //   flag=false
    // // }
    // // else{
    // //   this.expiryDateFlagValid=false
    // // }
   
      if (flag == true) {
        this.step2SaveApiCall()
   
        window.scrollTo(0, 0);
        this.showChangePolicy=true;
        this.showChangePolicyStepOne=false;
        this.showChangePolicyStepTwo=true;
        //this.showChangePolicyStepTwoB=true;
         this.showChangePolicyStepThree=false;
         this.showChangePolicyStepThreeAdminFee=false;
        //this.showChangePolicyStepThreeAdminFee=true;  //new
        this.showChangePolicyStepFour=false;
        this.showChangePolicyStepFive=false;
        this.showSearchedPolicy=false;
        this.showPolicyDetails=false;
        this.showPolicySearch=false;
        this.showRefundPolicy=false;
        this.showAudtiLogs=false;
        for(let i=0;i<this.travellerInfo.length;i++){
          var obj={}    
        
          obj["age"]= this.travellerInfo[i].age;
          obj["arrivalDateInCanada"]=this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd");
          obj["arrivalDateOfCanada"]=this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd");
          obj["country"]=  this.travellerInfo[i].homeCountry;
          obj["dateOfBirth"]= this.travellerInfo[i].dateOfBirth;
          obj["dayTimePhone"]= ""
          obj["deductableOptionId"]= ""
          obj["departureCity"]= this.travellerInfo[i].homeCountry;
          obj["eligable"]= "true"
          obj["emailAddress"]= ""
          obj["firstName"]= this.travellerInfo[i].firstName;
          obj["insitute"]= this.travellerInfo[i].insitute
          obj["language"]= this.language
          obj["lastName"]= this.travellerInfo[i].lastName;
          obj["premium"]= 0;
          obj["questionsansers"]=[]
          obj["tripCost"]= 0
          obj["insuredId"]=this.travellerInfo[i].id
          obj["waitPeroid"]= this.travellerInfo[i].waitPeroid;
          this.travellerInfoDetailsToSend.push(obj)
          }
        const request = 
        {
       "agentId": this.agentId,
       "declaration": true,
       "deductableOptions": [
        {
          "amount": 0,
          "createdAt": "",
          "createdBy": "",
          "id": 0,
          "lastModifiedBy": "",
          "option": "",
          "reduceAmount": 0,
          "updatedAt": ""
        }
       ],
       "language": this.selectedQuestionlanguages1,
       "noOfDays": this.calculatedDays,
       "optionalInformation": {
        "agentNote": this.agentNote,
        "beneficiary":this.beneficiary,
        "comment": this.comment
       },
       "paymentInformation": {
        "amount": 0,
        "cardNumber": "",
        "cardType": "",
        "cvv": "",
        "expiryDate": ""
       },
       "primaryAddress": {
        "address1": this.primaryAddress1,
        "address2": this.primaryAddress2,
        "city": this.primaryCity,
        "postalCode": this.primaryPostalCode,
        "province":this.primaryProvince
       },
       "isSameAddress": this.purchaserAddressSame,
       "questionsansers": [
       
       ],
       "residentOf": this.purchaseProvince,
       "returnDate": this.expiryDate,
       "secondaryAddress": {
        "address1": "",
        "address2": "",
        "city": "",
        "postalCode": "",
        "province":""
       },
       "selectedPlan": {},
       "startDate": this.startDate,
       "travellerInformation": this.travellerInfo,
       "travelllerDetails": this.travellerInfoDetailsToSend,
       "visitorsToCanada": "yes",
       "purchaserInformation":{
        "country":"",
        "emailAddress": this.purchaseEmail,
        "firstName": this.purchaserFirstName,
        "language": "",
        "lastName": this.purchaserLastName,
        "phoneNumber1": this.purchasePhone1,
        "phoneNumber2": this.purchasePhone2,
        "postalCode": this.purchasePostalCode,
        "province": this.purchaseProvince,
        "purchaserAddress": {
          "address1": this.purchaserAddress1,
          "address2": this.purchaserAddress2,
          "city": this.purchaseCity,
          "postalCode": this.purchasePostalCode
       }
      }
         }
             this.base.callPostService(this.config.postApistep1, request).subscribe((data: any) => {
              
        this.planQuoteResponses = data.data.planQuoteResponses;
       
        this.startDateShow=data.data.salesRequest.startDate;
        this.expiryDateShow=data.data.salesRequest.returnDate;
        this.resdentShowShow=data.data.salesRequest.residentOf;
        this.daysToshow = this.calculatedDays;
        this.travellerInformation=[]
        for(let i=0;i<data.data.salesRequest.travellerInformation.length;i++){
          var obj = {}
          obj["age"]=data.data.salesRequest.travellerInformation[i].age
          obj["arrivalDateOfCanada"]=data.data.salesRequest.travellerInformation[i].arrivalDateOfCanada
          obj["dateOfBirth"]=data.data.salesRequest.travellerInformation[i].dateOfBirth
          obj["waitPeroid"]=data.data.salesRequest.travellerInformation[i].waitPeroid
          obj["notEligibleFlag"]=false
          obj["checkDeclaration"]=false
         
          this.travellerInformation.push(obj);
        }
        
        this.qestionInfoArray = data.data.questions;
        this.qestionInfoArrayShow=[];
        this.qestionInfoArrayShow.push(this.qestionInfoArray[0]);
        window.scrollTo(0, 0);
        this.showChangePolicy=true;
        this.showChangePolicyStepOne=false;
        this.showChangePolicyStepTwo=true;
        //this.showChangePolicyStepTwoB=true;
         this.showChangePolicyStepThree=false;
         this.showChangePolicyStepThreeAdminFee=false;
        //this.showChangePolicyStepThreeAdminFee=true;  //new
        this.showChangePolicyStepFour=false;
        this.showChangePolicyStepFive=false;
        this.showSearchedPolicy=false;
        this.showPolicyDetails=false;
        this.showPolicySearch=false;
        this.showRefundPolicy=false;
        this.showAudtiLogs=false;
        // this.showChooseQuote=false;
        // this.showIntStudPlan=true;
        // this.showIntStudPlanStep1=false;
        // this.showIntStudPlanPlanOption=true;
        // this.showQuestionnaire=false;
        // this.showContactInfo=false;
        // this.showPayment=false;
        // this.showPaymentsDetails=false;
           }, error => {
             
        }, () => { });
    }
       }
      
      
    //     this.base.callPostService(this.config.postApistep1, request).subscribe((data: any) => {
    //     this.planQuoteResponses = data.data.planQuoteResponses;
    //     this.startDateShow=data.data.salesRequest.startDate;
    //     this.expiryDateShow=data.data.salesRequest.returnDate;
    //     this.resdentShowShow=data.data.salesRequest.residentOf;
    //     this.daysToshow = this.calculatedDays;
    //     this.travellerInformation = data.data.salesRequest.travellerInformation;
    //     // for(let i=0;i<data.data.salesRequest.travellerInformation.length;i++){
    //     //   var obj={}
    //     //   obj["age"]=data.data.salesRequest.travellerInformation[i].age
    //     //   obj["arrivalDateOfCanada"]=data.data.salesRequest.travellerInformation[i].arrivalDateOfCanada
    //     //   obj["dateOfBirth"]=data.data.salesRequest.travellerInformation[i].dateOfBirth
    //     //   obj["waitPeroid"]=data.data.salesRequest.travellerInformation[i].waitPeroid
    //     //   obj["checkToggleButtonYesbtn"]="Active1"
    //     //   obj["checkToggleButtonNobtn"]="Active1"
    //     //   this.travellerInformation.push(obj)
    //     // }
    //     this.qestionInfoArray = data.data.questions;
    //     this.qestionInfoArrayShow=[];
    //     this.qestionInfoArrayShow.push(this.qestionInfoArray[0]);
    //     window.scrollTo(0, 0);
    //     this.showChangePolicy=true;
    //     this.showChangePolicyStepOne=false;
    //     this.showChangePolicyStepTwo=true;
    //     //this.showChangePolicyStepTwoB=true;
    //      this.showChangePolicyStepThree=false;
    //      this.showChangePolicyStepThreeAdminFee=false;
    //     //this.showChangePolicyStepThreeAdminFee=true;  //new
    //     this.showChangePolicyStepFour=false;
    //     this.showChangePolicyStepFive=false;
    //     this.showSearchedPolicy=false;
    //     this.showPolicyDetails=false;
    //     this.showPolicySearch=false;
    //     this.showRefundPolicy=false;
    //     this.showAudtiLogs=false;
    //     // this.showChooseQuote=false;
    //     // this.showIntStudPlan=true;
    //     // this.showIntStudPlanStep1=false;
    //     // this.showIntStudPlanPlanOption=true;
    //     // this.showQuestionnaire=false;
    //     // this.showContactInfo=false;
    //     // this.showPayment=false;
    //     // this.showPaymentsDetails=false;
    //        }, error => {
             
    //     }, () => { });
    // }
    //    }
  
  
    showChangePolicy:boolean=true;
    showChangePolicyStepOne:boolean=true;
    showChangePolicyStepTwo:boolean=false;
    showChangePolicyStepTwoB:boolean=false;
    showChangePolicyStepThree:boolean=false;
    showChangePolicyStepThreeAdminFee:boolean=false;
    showChangePolicyStepFour:boolean=false;
    showChangePolicyStepFive:boolean=false;
  
    onClickChangePolicy(){
      window.scrollTo(0, 0);
      this.showChangePolicy=true;
      this.showChangePolicyStepOne=true;
      this.showChangePolicyStepTwo=false;
      this.showChangePolicyStepTwoB=false;
      this.showChangePolicyStepThree=false;
      this.showChangePolicyStepThreeAdminFee=false;
      this.showChangePolicyStepFour=false;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
    }
    onClickChangePolicyStepOneNext(){
      window.scrollTo(0, 0);
      this.showChangePolicy=true;
      this.showChangePolicyStepOne=false;
      this.showChangePolicyStepTwo=true;
      this.showChangePolicyStepTwoB=false;
      this.showChangePolicyStepThree=false;
      this.showChangePolicyStepThreeAdminFee=false;
      this.showChangePolicyStepFour=false;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
      var flag=true;
  if(!this.expiryDate){this.expiryDateFlag=true;flag=false}else{this.expiryDateFlag=false;this.expiryDateFlagValid=false}
  if(!this.startDate){this.startDateFlag=true;flag=false}else{this.startDateFlag=false;this.startDateFlagValid=false}
  if(!this.travellerInfo[0].arrivalDateOfCanada){this.arrivalDateCanadaFlag=true;flag=false}else{this.arrivalDateCanadaFlag=false}
  if(!this.travellerInfo[0].dateOfBirth){this.dobFlag=true;flag=false}else{this.dobFlag=false}
   this.expiryDate = this.datePipe.transform(this.expiryDate, "yyyy-MM-dd");
   this.startDate = this.datePipe.transform(this.startDate, "yyyy-MM-dd");
  
    }
    purchaserAddress2: any;
    firstNameFlag: boolean=false;
    lastNameFlag: boolean=false;
    InstituteFlag: boolean=false;
    CountryFlag: boolean=false;
    
    removeFirstNameError(i){
      // this.firstNameFlag=false
           this.insuredPersonArray[i].firstNameFlag=false;
         }
         removeLastNameError(i){
          // this.lastNameFlag=false;
          this.insuredPersonArray[i].lastNameFlag=false;
        }
        removeInstituteNameError(i){
          // this.InstituteFlag=false;
          this.insuredPersonArray[i].InstituteFlag=false;
        }
        removeCountryNameError(i){
          // this.CountryFlag=false;
          this.insuredPersonArray[i].CountryFlag=false;
        }
  
   countryListing: any=[];
  getcountryListing(){
    this.user.getCountryDropdown().subscribe((data:any) =>{
     this.countryListing = data.data;
    },error=>{{
    //handle Exception from Server 404,401
    }},()=>{});
  }
  
  
    onClickChangePolicyStepOneBack(){
      window.scrollTo(0, 0);
      
      // this.showChangePolicy=false;
      // this.showChangePolicyStepOne=false;
      // this.showChangePolicyStepTwo=false;
      // this.showChangePolicyStepTwoB=false;
      // this.showChangePolicyStepThree=false;
      // this.showChangePolicyStepThreeAdminFee=false;
      // this.showChangePolicyStepFour=false;
      // this.showChangePolicyStepFive=false;
      // this.showSearchedPolicy=false;
      // this.showPolicyDetails=true;
      // this.showPolicySearch=false;
      // this.showRefundPolicy=false;
      // this.showAudtiLogs=false;
    }
    onClickChangePolicyStepTwoNext(){
      window.scrollTo(0, 0);
      this.showChangePolicy=true;
      this.showChangePolicyStepOne=false;
      this.showChangePolicyStepTwo=true;
      this.showChangePolicyStepTwoB=false;
      this.showChangePolicyStepThree=true;
      this.showChangePolicyStepThreeAdminFee=false;
      this.showChangePolicyStepFour=false;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
    }
    onClickChangePolicyStepTwoBack(){
      window.scrollTo(0, 0);
      this.showChangePolicy=true;
      this.showChangePolicyStepOne=true;
      this.showChangePolicyStepTwo=false;
      this.showChangePolicyStepTwoB=false;
      this.showChangePolicyStepThree=false;
      this.showChangePolicyStepThreeAdminFee=false;
      this.showChangePolicyStepFour=false;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
    }
    onClickChangePolicyStepTwoBNext(){
      window.scrollTo(0, 0);
      this.showChangePolicy=true;
      this.showChangePolicyStepOne=false;
      this.showChangePolicyStepTwo=false;
      this.showChangePolicyStepTwoB=false;
      this.showChangePolicyStepThree=true;
      //this.showChangePolicyStepThreeAdminFee=false;
      this.showChangePolicyStepThreeAdminFee=true   //new line added
      this.showChangePolicyStepFour=false;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
    }
    onClickChangePolicyStepTwoBBack(){
      window.scrollTo(0, 0);
      this.showChangePolicy=true;
      this.showChangePolicyStepOne=false;
      this.showChangePolicyStepTwo=true;
      this.showChangePolicyStepTwoB=false;
      //this.showChangePolicyStepTwoB=true;       //new line
      this.showChangePolicyStepThree=false;
      this.showChangePolicyStepThreeAdminFee=false;
      //this.showChangePolicyStepThreeAdminFee=true;
      this.showChangePolicyStepFour=false;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
    }
    onClickChangePolicyStepThreeNext(){
      window.scrollTo(0, 0);
      this.showChangePolicy=true;
      this.showChangePolicyStepOne=false;
      this.showChangePolicyStepTwo=false;
      this.showChangePolicyStepTwoB=false;
      this.showChangePolicyStepThree=false;
      this.showChangePolicyStepThreeAdminFee=true;
      this.showChangePolicyStepFour=false;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
    }
    // onClickChangePolicyStepThreeBack(){
    //   window.scrollTo(0, 0);
    //   this.showChangePolicy=true;
    //   this.showChangePolicyStepOne=false;
    //   this.showChangePolicyStepTwo=false;
    //   this.showChangePolicyStepTwoB=true;
    //   this.showChangePolicyStepThree=false;
    //   this.showChangePolicyStepThreeAdminFee=false;
    //   this.showChangePolicyStepFour=false;
    //   this.showChangePolicyStepFive=false;
    //   this.showSearchedPolicy=false;
    //   this.showPolicyDetails=false;
    //   this.showPolicySearch=false;
    //   this.showRefundPolicy=false;
    // }
    onClickChangePolicyStepThreeBack(){
      window.scrollTo(0, 0);
      this.showChangePolicy=true;
      this.showChangePolicyStepOne=false;
      this.showChangePolicyStepTwo=true;
      this.showChangePolicyStepTwoB=false;
      this.showChangePolicyStepThree=false;
      this.showChangePolicyStepThreeAdminFee=false;
      this.showChangePolicyStepFour=false;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
    }
    adminfeeerror:boolean=false
  adminFeeReasonerror:boolean=false
  onadminFeeClick(){
    this.adminfeeerror=false
  }
  onadminFeeReasonClick(){
    this.adminFeeReasonerror=false
  }
    onClickChangePolicyStepThreeAdminTreeNext(){
      var flag=true
  
      if(!this.adminFee || this.adminFee==""){flag=false;this.adminfeeerror=true}else{this.adminfeeerror=false}
       if(!this.adminFeeReason || this.adminFeeReason==""){flag=false;this.adminFeeReasonerror=true}else{this.adminFeeReasonerror=false}
      if(flag==true){
       window.scrollTo(0, 0);
      this.showChangePolicy=true;
      this.showChangePolicyStepOne=false;
      this.showChangePolicyStepTwo=false;
      this.showChangePolicyStepTwoB=false;
      this.showChangePolicyStepThree=false;
      this.showChangePolicyStepThreeAdminFee=false;
      this.showChangePolicyStepFour=true;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
      
      var adminFeeAmount = this.adminFee;
      var convertAmount = this.Amount;
      while(adminFeeAmount.charAt(0) === '$')
      {
        adminFeeAmount = adminFeeAmount.substring(1);
      }
      
      adminFeeAmount=adminFeeAmount.replace (/,/g, "");
      if(this.Amount!=null){
        var convertAmount = this.Amount;
      convertAmount=convertAmount.replace ("$", "");
      convertAmount=convertAmount.replace (/,/g, "");
      }
      var sslAmount = this.ssl_account_balance;
      
      while(sslAmount.charAt(0) === '$')
         {
          sslAmount = sslAmount.substring(1);
         }
         
         sslAmount=sslAmount.replace (/,/g, "");
         var tripcost = this.Tripcost;
      while(tripcost.charAt(0) === '$')
         {
          tripcost = tripcost.substring(1);
         }
         
         tripcost=tripcost.replace (/,/g, "");
      // this.travellerInfo
      this.travellerInfoToSend=[]
      for(let i=0;i<this.travellerInfo.length;i++){
        var obj={}    
        obj["age"]= this.travellerInfo[i].age;
        obj["eligable"]= "true";
        obj["arrivalDateOfCanada"]= this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd");
        obj["waitPeroid"]=  this.travellerInfo[i].waitPeroid;
        obj["dateOfBirth"]= this.travellerInfo[i].dateOfBirth;
       
        this.travellerInfoToSend.push(obj)
      }
      this.travellerInfoDetailsToSend=[]
  for(let i=0;i<this.travellerInfo.length;i++){
    var obj={}    
  
    obj["age"]= this.travellerInfo[i].age;
    obj["arrivalDateInCanada"]= this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd");
    obj["arrivalDateOfCanada"]= this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd");
    obj["country"]=  this.travellerInfo[i].homeCountry;
    obj["dateOfBirth"]= this.travellerInfo[i].dateOfBirth;
    obj["dayTimePhone"]= ""
    obj["deductableOptionId"]= ""
    obj["departureCity"]= this.travellerInfo[i].homeCountry;
    obj["eligable"]= "true"
    obj["emailAddress"]= ""
    obj["firstName"]= this.travellerInfo[i].firstName;
    obj["insitute"]= this.travellerInfo[i].insitute
    obj["language"]= this.language
    obj["lastName"]= this.travellerInfo[i].lastName;
    obj["premium"]= 0;
    obj["questionsansers"]=[]
    obj["tripCost"]= 0
    obj["insuredId"]=this.travellerInfo[i].id
    obj["waitPeroid"]= this.travellerInfo[i].waitPeroid;
    this.travellerInfoDetailsToSend.push(obj)
    }
      const request=
      {
        "adminFee": adminFeeAmount,
        "agentId": this.agentId,
        "declaration": true,
        "deductableOptions": [
          {
            "amount": 0,
            "createdAt":"",
            "createdBy": "string",
            "id": 0,
            "lastModifiedBy": "string",
            "option": "string",
            "reduceAmount": 0,
            "updatedAt": ""
          }
        ],
        "feeReason": this.adminFeeReason,
        "language": this.selectedQuestionlanguages1,
        "noOfDays": this.calculatedDays,
        "optionalInformation": {
          "agentNote":  this.agentNote,
          "beneficiary": this.beneficiary,
          "comment": this.comment
        },
        "paymentInformation": {
          "amount": convertAmount,
          "cardNumber": this.ssl_card_number,
          "cardType":  this.ssl_card_type,
          "cvv": "",
          "expiryDate": this.ssl_exp_date
        },
        "paymetChangeResponse": {
          "amount": convertAmount,
          "premimum": "",
          "previousPayment": "",
          "tax": this.Tax,
          "totalAdminFee": this.adminFee,
          "totalBillingFee": ""
        },
        "refundPolicyRequest": {
          "amount": 0,
          "policyId": 0,
          "refundReason": "",
          "txnId": ""
        },
        "policyId": this.policyId,
        "primaryAddress": {
          "address1": this.primaryAddress1,
          "address2": this.primaryAddress2,
          "city": this.primaryCity,
          "postalCode":this.primaryPostalCode,
          "province":this.primaryProvince
        },
        "isSameAddress": this.purchaserAddressSame,
        "purchaserInformation": {
          "country": "",
          "emailAddress":this.purchaseEmail,
          "firstName": this.purchaserFirstName,
          "language": this.selectedQuestionlanguages1,
          "lastName": this.purchaserLastName,
          "phoneNumber1": this.purchasePhone1,
          "phoneNumber2": this.purchasePhone2,
          "postalCode": this.purchasePostalCode,
          "province": this.purchaseProvince,
          "purchaserAddress": {
            "address1": this.purchaserAddress1,
            "address2": this.purchaserAddress2,
            "city": this.purchaseCity,
            "postalCode": this.purchasePostalCode,
            "province": this.purchaseProvince
          }
        },
        "questionsansers": [
          {
            "answer": "string",
            "question": "string",
            "quetionId": 0
          }
        ],
        "quoteDescriptions": "string",
        "quoteName": "string",
        "residentOf": this.purchaseProvince,
        "returnDate": this.expiryDate,
        "salesType": this.salesType,
        "secondaryAddress": {
          "address1": "string",
          "address2": "string",
          "city": "string",
          "postalCode": "string",
          "province": "string"
        },
        "selectedPlan": {
          "planDescription": "string",
          "planId": this.planId,
          "planName": this.planName,
          "policyPdf": "",
          "questions": [
            {
              "createdAt": "",
              "createdBy": "",
              "id": 0,
              "lastModifiedBy": "",
              "plans": {
                "createdAt": "",
                "createdBy": "",
                "id": 0,
                "lastModifiedBy": "",
                "planCode": "",
                "planDescription": "",
                "planLineCode": "string",
                "planLineDescription": "string",
                "planName": this.planName,
                "policyPdf": "",
                "rate": 0,
                "updatedAt": ""
              },
              "question": "string",
              "questionOptions": [
                {
                  "createdAt": "",
                  "createdBy": "",
                  "id": 0,
                  "isEligible": true,
                  "lastModifiedBy": "",
                  "option": "string",
                  "updatedAt": ""
                }
              ],
              "updatedAt": ""
            }
          ],
          "totalAmount": "string"
        },
        "startDate": this.startDate,
        "transactionResponse": {
          "ssl_account_balance":sslAmount,
          "ssl_add_token_response": "string",
          "ssl_address2": "",
          "ssl_amount":convertAmount,
          "ssl_approval_code": this.ssl_approval_code,
          "ssl_avs_response": this.ssl_avs_response,
          "ssl_avs_address": this.ssl_avs_address,
          "ssl_avs_zip": this.ssl_avs_zip,
          "ssl_card_number": this.ssl_card_number,
          "ssl_card_short_description": this.ssl_card_short_description,
          "ssl_card_type":  this.ssl_card_type,
          "ssl_city": "",
          "ssl_company": "",
          "ssl_completion_date": "",
          "ssl_country": "",
          "ssl_customer_code": "",
          "ssl_cvv2_response": this.ssl_cvv2_response,
          "ssl_departure_date": "",
          "ssl_description": "",
          "ssl_email": "",
          "ssl_exp_date": this.ssl_exp_date,
          "ssl_first_name": "",
          "ssl_get_token": "",
          "ssl_invoice_number": "",
          "ssl_issuer_response": this.ssl_issuer_response,
          "ssl_last_name": "",
          "ssl_merchant_initiated_unscheduled": this.ssl_merchant_initiated_unscheduled,
          "ssl_oar_data": "",
          "ssl_partner_app_id": this.ssl_partner_app_id,
          "ssl_phone": "",
          "ssl_ps2000_data": this.ssl_ps2000_data,
          "ssl_result": this.ssl_result,
          "ssl_result_message": this.ssl_result_message,
          "ssl_salestax": "",
          "ssl_ship_to_address1": "",
          "ssl_ship_to_zip": "",
          "ssl_state": "",
          "ssl_token": this.ssl_token,
          "ssl_token_response": this.ssl_token_response,
          "ssl_transaction_currency": this.ssl_transaction_currency,
          "ssl_transaction_reference_number": this.ssl_transaction_reference_number,
          "ssl_transaction_type": this.ssl_transaction_type,
          "ssl_txn_id": this.transactionID,
          "ssl_txn_time": this.ssl_txn_time
        },
         "travellerInformation": this.travellerInfoToSend,
        // [
        //   {
        //     "age": "string",
        //     "arrivalDateOfCanada": "",
        //     "dateOfBirth": "",
        //     "eligable": true,
        //     "waitPeroid": "string"
        //   }
        // ],
        "travelllerDetails":this.travellerInfoDetailsToSend,
        "visitorsToCanada": ""
      }
      
      this.base.callPostService(this.config.PostChangePolicy, request).subscribe((data: any) => {
        //console.log(data.data)
        this.insuredinfoArray=[]
        this.fulfillmentArray=[]
        this.PreviousPayments=data.data.paymetChangeResponse.previousPayment
        this.TotalBillingFee=data.data.paymetChangeResponse.totalBillingFee
        this.adminFee=data.data.paymetChangeResponse.totalAdminFee
        this.Tax=data.data.paymetChangeResponse.tax
        this.Amounttotal=data.data.paymetChangeResponse.amount
        this.fulfillmentArray=data.data.policyFulfillments
        if(this.Amounttotal.charAt(0) === '-'){
          this.Refund="Refund Amount"
          this.FinalizeBtnName="Process Refund"
        }
        else{
          var p =this.Amounttotal
          p=p.replace ("$", "");
        if(p==0){
          this.Refund="No Charge"
        }
        else{
          // this.Refund=false
          this.Refund="Payment Amount"
          this.FinalizeBtnName="Finalize Payment"
        }
        }
        // this.Amount=data.data.transactionResponse.ssl_amount
        this.Amount=data.data.paymetChangeResponse.amount
        this.PaymentPremium=data.data.paymetChangeResponse.premimum
        this.insuredinfoArray=data.data.travelllerDetails
        
           }, error => {{
            if (error.status == 400) {
            }
          }
        }, () => { });
      }
    }
  
    onClickChangePolicyStepThreeAdminTreeBack(){
      window.scrollTo(0, 0);
      this.showChangePolicy=true;
      this.showChangePolicyStepOne=false;
      this.showChangePolicyStepTwo=false;
      //this.showChangePolicyStepTwoB=false;
      //this.showChangePolicyStepTwoB=true;     //new 
      this.showChangePolicyStepThree=true;
      this.showChangePolicyStepThreeAdminFee=false;
      this.showChangePolicyStepFour=false;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
    }
    onClickChangePolicyStepFourNext(){
      
  
      // window.scrollTo(0, 0);
      // this.showChangePolicy=true;
      // this.showChangePolicyStepOne=false;
      // this.showChangePolicyStepTwo=false;
      // this.showChangePolicyStepTwoB=false;
      // this.showChangePolicyStepThree=false;
      // this.showChangePolicyStepThreeAdminFee=false;
      // this.showChangePolicyStepFour=false;
      // this.showChangePolicyStepFive=true;
      // this.showSearchedPolicy=false;
      // this.showPolicyDetails=false;
      // this.showPolicySearch=false;
      // this.showRefundPolicy=false;
      // this.showAudtiLogs=false;
     
  if(this.Refund=="Refund Amount" || this.Refund=="No Charge")
  {
    this.policypremium=0
  }
  else{
    var atotal=this.Amounttotal
    atotal=atotal.replace (/,/g, "");
    atotal=atotal.replace ("$", "");
  
    this.policypremium=atotal
  }
  
  
  
  
  //     this.responseID=localStorage.getItem('responseID');
  //   console.log(this.responseID)
  //   if(this.responseID!=null && this.responseID!=undefined && this.responseID!="undefined")
  //   {
  //     this.blockUI.stop()
  // Swal.fire('',this.responseID,'error')
  // this.responseID=null;
  // localStorage.removeItem('responseID');
             
  // localStorage.removeItem('ssl_first_name');
  // localStorage.removeItem('transactionID');
  // localStorage.removeItem('ssl_last_name');
  // localStorage.removeItem('amount');
  // localStorage.removeItem('ssl_merchant_initiated_unscheduled');
  // localStorage.removeItem('ssl_issuer_response');
  // localStorage.removeItem('ssl_partner_app_id');
  // localStorage.removeItem('ssl_card_number');
  // localStorage.removeItem('ssl_transaction_type');
  // localStorage.removeItem('ssl_transaction_reference_number');
  // localStorage.removeItem('ssl_result');
  // localStorage.removeItem('ssl_approval_code');
  // localStorage.removeItem('ssl_txn_time');
  // localStorage.removeItem('ssl_amount');
  // localStorage.removeItem('ssl_transaction_currency');
  // localStorage.removeItem('ssl_account_balance');
  // localStorage.removeItem('ssl_ps2000_data');
  // localStorage.removeItem('ssl_exp_date');
  // localStorage.removeItem('ssl_result_message');
  // localStorage.removeItem('ssl_card_short_description');
  // localStorage.removeItem('ssl_get_token');
  // localStorage.removeItem('ssl_token_response');
  // localStorage.removeItem('ssl_card_type');
  // localStorage.removeItem('ssl_cvv2_response');
  // localStorage.removeItem('ssl_add_token_response');
  // localStorage.removeItem('ssl_avs_response');
  // localStorage.removeItem('ssl_first_name');
  // localStorage.removeItem('ssl_last_name');
  // localStorage.removeItem('ssl_oar_data');
  // localStorage.removeItem('ssl_get_token');
  // localStorage.removeItem('ssl_salestax');
  // localStorage.removeItem('ssl_token');
  // localStorage.removeItem('ssl_avs_address');
  // localStorage.removeItem('ssl_avs_zip');
  //   }
  //   else{
      this.ssl_result_message=localStorage.getItem('ssl_result_message');
      console.log(this.ssl_result_message)
      // if(this.ssl_result_message=="INVALID ISSUER"){
      //   this.blockUI.stop()
      //   Swal.fire('',"INVALID ISSUER. Please verify your card details and try again",'error')
        
      // }
      // if(this.paymentInfo==true && this.ssl_result_message !=="APPROVAL"){
      //   this.blockUI.stop()
      //   if(this.ssl_result_message=="EXPIRED CARD") {
      //     Swal.fire('',"Invalid expiry date",'error')
      //   }
      //   else{
      //   Swal.fire('',this.ssl_result_message,'error')
      //     }
      //   localStorage.removeItem('responseID');
      //   localStorage.removeItem('ssl_first_name');
      //   localStorage.removeItem('transactionID');
      //   localStorage.removeItem('ssl_last_name');
      //   localStorage.removeItem('amount');
      //   localStorage.removeItem('ssl_merchant_initiated_unscheduled');
      //   localStorage.removeItem('ssl_issuer_response');
      //   localStorage.removeItem('ssl_partner_app_id');
      //   localStorage.removeItem('ssl_card_number');
      //   localStorage.removeItem('ssl_transaction_type');
      //   localStorage.removeItem('ssl_transaction_reference_number');
      //   localStorage.removeItem('ssl_result');
      //   localStorage.removeItem('ssl_approval_code');
      //   localStorage.removeItem('ssl_txn_time');
      //   localStorage.removeItem('ssl_amount');
      //   localStorage.removeItem('ssl_transaction_currency');
      //   localStorage.removeItem('ssl_account_balance');
      //   localStorage.removeItem('ssl_ps2000_data');
      //   localStorage.removeItem('ssl_exp_date');
      //   localStorage.removeItem('ssl_result_message');
      //   localStorage.removeItem('ssl_card_short_description');
      //   localStorage.removeItem('ssl_get_token');
      //   localStorage.removeItem('ssl_token_response');
      //   localStorage.removeItem('ssl_card_type');
      //   localStorage.removeItem('ssl_cvv2_response');
      //   localStorage.removeItem('ssl_add_token_response');
      //   localStorage.removeItem('ssl_avs_response');
      //   localStorage.removeItem('ssl_first_name');
      //   localStorage.removeItem('ssl_last_name');
      //   localStorage.removeItem('ssl_oar_data');
      //   localStorage.removeItem('ssl_get_token');
      //   localStorage.removeItem('ssl_salestax');
      //   localStorage.removeItem('ssl_token');
      //   localStorage.removeItem('ssl_avs_address');
      //   localStorage.removeItem('ssl_avs_zip');
      // }
      //   else{
    // this.transactionID=localStorage.getItem('transactionID');
    // this.amount=localStorage.getItem('amount');
    // this.ssl_merchant_initiated_unscheduled=localStorage.getItem('ssl_merchant_initiated_unscheduled');
    // this.ssl_issuer_response=localStorage.getItem('ssl_issuer_response');
    // this.ssl_partner_app_id=localStorage.getItem('ssl_partner_app_id');
    // this.ssl_card_number=localStorage.getItem('ssl_card_number');
    // this.ssl_transaction_type=localStorage.getItem('ssl_transaction_type');
    // this.ssl_transaction_reference_number=localStorage.getItem('ssl_transaction_reference_number');
    // this.ssl_result=localStorage.getItem('ssl_result');
    // this.ssl_approval_code=localStorage.getItem('ssl_approval_code');
    // this.ssl_txn_time=this.datePipe.transform(localStorage.getItem('ssl_txn_time'), "dd/MM/yyyy HH:mm:ss a");
    // this.amount=localStorage.getItem('ssl_amount');
    // this.ssl_transaction_currency=localStorage.getItem('ssl_transaction_currency');
    // this.ssl_account_balance=localStorage.getItem('ssl_account_balance');
    // this.ssl_ps2000_data=localStorage.getItem('ssl_ps2000_data');
    // this.ssl_exp_date=localStorage.getItem('ssl_exp_date');
    // this.ssl_result_message=localStorage.getItem('ssl_result_message');
    // this.ssl_card_short_description=localStorage.getItem('ssl_card_short_description');
    // this.ssl_token_response=localStorage.getItem('ssl_token_response');
    // this.ssl_card_type=localStorage.getItem('ssl_card_type');
    
    // this.ssl_add_token_response=localStorage.getItem('ssl_add_token_response');
    // this.ssl_avs_response=localStorage.getItem('ssl_avs_response');
    // this.ssl_first_name=localStorage.getItem('ssl_first_name');
    // this.ssl_last_name=localStorage.getItem('ssl_last_name');
    // this.ssl_oar_data=localStorage.getItem('ssl_oar_data');
    // this.ssl_get_token=localStorage.getItem('ssl_get_token');
    // this.ssl_salestax=localStorage.getItem('ssl_salestax');
    // this.ssl_token=localStorage.getItem('ssl_token');
    // this.ssl_avs_address=localStorage.getItem('ssl_avs_address');
    // this.ssl_avs_zip=localStorage.getItem('ssl_avs_zip');
    var adminFeeAmount = this.adminFee;
      // while(adminFeeAmount.charAt(0) === '$')
      // {
      //   adminFeeAmount = adminFeeAmount.substring(1);
      // }
      
      
      adminFeeAmount=adminFeeAmount.replace (/,/g, "");
      adminFeeAmount=adminFeeAmount.replace ("$", "");
      if(this.AmounttoPay!=null){
      var convertAmount = this.AmounttoPay;
      // while(convertAmount.charAt(0) === '$')
      //    {
      //      convertAmount = convertAmount.substring(1);
      //    }
         
         convertAmount=convertAmount.replace (/,/g, "");
         convertAmount=convertAmount.replace ("$", "");
      }
      if(this.ssl_account_balance!=null){
      var sslAmount = this.ssl_account_balance;
     
      // while(sslAmount.charAt(0) === '$')
      //    {
      //     sslAmount = sslAmount.substring(1);
      //    }
         
         sslAmount=sslAmount.replace (/,/g, "");
         sslAmount=sslAmount.replace ("$", "");
      }
      if(this.Tripcost!=null){
         var tripcost = this.Tripcost;
        //  while(tripcost.charAt(0) === '$')
        //     {
        //      tripcost = tripcost.substring(1);
        //     }
            
            tripcost=tripcost.replace (/,/g, "");
            tripcost=tripcost.replace ("$", "");
      }
  if(this.PaymentPremium!=null){
            // while(this.PaymentPremium.charAt(0) === '$')
            // {
            //   this.PaymentPremium = this.PaymentPremium.substring(1);
            // }
            
            this.PaymentPremium=this.PaymentPremium.replace (/,/g, "");
            this.PaymentPremium=this.PaymentPremium.replace ("$", "");
          }
  if(this.PreviousPayments!=null){
            // while(this.PreviousPayments.charAt(0) === '$')
            // {
            //   this.PreviousPayments = this.PreviousPayments.substring(1);
            // }
            
            this.PreviousPayments=this.PreviousPayments.replace (/,/g, "");
            this.PreviousPayments=this.PreviousPayments.replace ("$", "");
          }
  if(this.Tax!=null){
            // while(this.Tax.charAt(0) === '$')
            // {
            //   this.Tax = this.Tax.substring(1);
            // }
            
            this.Tax=this.Tax.replace (/,/g, "");
            this.Tax=this.Tax.replace ("$", "");
          }
  if(this.adminFee!=null){
            // while(this.adminFee.charAt(0) === '$')
            // {
            //   this.adminFee = this.adminFee.substring(1);
            // }
            
            this.adminFee=this.adminFee.replace (/,/g, "");
            this.adminFee=this.adminFee.replace ("$", "");
          }
  if(this.TotalBillingFee!=null){
            // while(this.TotalBillingFee.charAt(0) === '$')
            // {
            //   this.TotalBillingFee = this.TotalBillingFee.substring(1);
            // }
            
            this.TotalBillingFee=this.TotalBillingFee.replace (/,/g, "");
            this.TotalBillingFee=this.TotalBillingFee.replace ("$", "");
          }
  
  
  
  if(this.refundPolicyRequest==null || this.refundPolicyRequest==undefined ){
    this.refundPolicyRequest=null
  }
  
  this.travellerInfoToSend=[]
  for(let i=0;i<this.travellerInfo.length;i++){
    var obj={}    
    obj["age"]= this.travellerInfo[i].age;
    obj["eligable"]= "true";
    obj["arrivalDateOfCanada"]= this.travellerInfo[i].arrivalDateOfCanada;
    obj["waitPeroid"]=  this.travellerInfo[i].waitPeroid;
    obj["dateOfBirth"]= this.travellerInfo[i].dateOfBirth;
   
    this.travellerInfoToSend.push(obj)
  }
  this.travellerInfoDetailsToSend=[]
  for(let i=0;i<this.travellerInfo.length;i++){
  
    var obj={}    
  
    obj["age"]= this.travellerInfo[i].age;
    obj["arrivalDateInCanada"]= this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd");
    obj["arrivalDateOfCanada"]=this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd");
    obj["country"]=  this.travellerInfo[i].homeCountry;
    obj["dateOfBirth"]= this.travellerInfo[i].dateOfBirth;
    obj["dayTimePhone"]= this.purchasePhone1
    obj["deductableOptionId"]= ""
    obj["departureCity"]= this.travellerInfo[i].homeCountry;
    obj["eligable"]= "true"
    obj["emailAddress"]= this.purchaseEmail
    obj["firstName"]= this.travellerInfo[i].firstName;
    obj["insitute"]= this.travellerInfo[i].insitute
    obj["language"]= this.language
    obj["lastName"]= this.travellerInfo[i].lastName;
    obj["premium"]= this.insuredinfoArray[i].premium;
    // obj["premium"]= 1;
    obj["questionsansers"]=[]
    obj["tripCost"]= 0;
    obj["insuredId"]=this.travellerInfo[i].id
    obj["waitPeroid"]= this.travellerInfo[i].waitPeroid;
    this.travellerInfoDetailsToSend.push(obj)
    }
    if(this.paymentInfo==true){
      // convertAmount=1
      // sslAmount=1
      var obj9={}
      obj9["ssl_account_balance"]= sslAmount,
      obj9["ssl_add_token_response"]= this.ssl_add_token_response,
      obj9["ssl_amount"]= convertAmount,
      obj9["ssl_approval_code"]= this.ssl_approval_code,
      obj9["ssl_avs_response"]= this.ssl_avs_response,
      obj9["ssl_card_number"]= this.ssl_card_number,
      obj9["ssl_card_short_description"]= this.ssl_card_short_description,
      obj9["ssl_card_type"]= this.ssl_card_type,
      obj9["ssl_cvv2_response"]= this.ssl_cvv2_response,
      obj9["ssl_exp_date"]= this.ssl_exp_date,
      obj9["ssl_first_name"]= this.ssl_first_name,
      obj9["ssl_get_token"]= this.ssl_get_token,
      obj9["ssl_issuer_response"]= this.ssl_issuer_response,
      obj9["ssl_last_name"]= this.ssl_last_name,
      obj9["ssl_merchant_initiated_unscheduled"]= this.ssl_merchant_initiated_unscheduled,
      obj9["ssl_oar_data"]= this.ssl_oar_data,
      obj9["ssl_partner_app_id"]= this.ssl_partner_app_id,
      obj9["ssl_ps2000_data"]= this.ssl_ps2000_data,
      obj9["ssl_result"]= this.ssl_result,
      obj9["ssl_result_message"]= this.ssl_result_message,
      obj9["ssl_salestax"]= this.ssl_salestax,
      obj9["ssl_token"]= this.ssl_token,
      obj9["ssl_token_response"]= this.ssl_token_response,
      obj9["ssl_transaction_currency"]= "CAD",
      obj9["ssl_transaction_reference_number"]= "",
      obj9["ssl_transaction_type"]= this.ssl_transaction_type,
      obj9["ssl_txn_id"]= this.transactionID,
      obj9["ssl_txn_time"]= this.ssl_txn_time
      obj9["ssl_avs_address"]= this.ssl_avs_address,
      obj9["ssl_avs_zip"]= this.ssl_avs_zip,
      this.transactionResponseArray=obj9
    }
    else{
  
      this.transactionResponseArray=null
    }
//     this.policypremium=1
// adminFeeAmount=0
//          convertAmount=1
// this.PaymentPremium=1
// this.PreviousPayments=1
// this.adminFee=0
// this.TotalBillingFee=1
if(this.ssl_card_type1 !==this.ssl_card_number){
  this.ccNumber=this.ssl_card_number1
}
else{
  this.ccNumber=this.ssl_card_number
}
      const request=
      {
        "isChange":this.isChange,
        "policyPremium":this.policypremium,
        "adminFee": adminFeeAmount,
        "agentId": this.agentId,
        "declaration": true,
        "deductableOptions": [
          {
            "amount": 0,
            "createdAt":null,
            "createdBy": "string",
            "id": 0,
            "lastModifiedBy": "string",
            "option": "string",
            "reduceAmount": 0,
            "updatedAt": null
          }
        ],
        "feeReason": this.adminFeeReason,
        "language": this.selectedQuestionlanguages1,
        "noOfDays": this.calculatedDays,
        "optionalInformation": {
          "agentNote":  this.agentNote,
          "beneficiary": this.beneficiary,
          "comment": this.comment
        },
        "paymentInformation": {
          "amount": convertAmount,
          "cardNumber": this.ssl_card_number1,
          "cardType":  this.ssl_card_type1,
          "cvv": this.ssl_cvv2_response1,
          "expiryDate": this.ssl_exp_date1
        },
        "refundPolicyRequest": this.refundPolicyRequest,
        "paymetChangeResponse": {
          "amount": convertAmount,
          "premimum": this.PaymentPremium,
          "previousPayment": this.PreviousPayments,
          "tax": this.Tax,
          "totalAdminFee": this.adminFee,
          "totalBillingFee": this.TotalBillingFee
        },
        "policyId": this.policyId,
        "primaryAddress": {
          "address1": this.primaryAddress1,
          "address2": this.primaryAddress2,
          "city": this.primaryCity,
          "postalCode":this.primaryPostalCode,
          "province":this.primaryProvince
        },
        "isSameAddress": this.purchaserAddressSame,
        "purchaserInformation": {
          "country": "",
          "emailAddress":this.purchaseEmail,
          "firstName": this.purchaserFirstName,
          "language": this.selectedQuestionlanguages1,
          "lastName": this.purchaserLastName,
          "phoneNumber1": this.purchasePhone1,
          "phoneNumber2": this.purchasePhone2,
          "postalCode": this.purchasePostalCode,
          "province": this.purchaseProvince,
          "purchaserAddress": {
            "address1": this.purchaserAddress1,
            "address2": this.purchaserAddress2,
            "city": this.purchaseCity,
            "postalCode": this.purchasePostalCode,
            "province": this.purchaseProvince
          }
        },
        "questionsansers": [
         
        ],
        "quoteDescriptions": "string",
        "quoteName": "string",
        "residentOf": this.purchaseProvince,
        "returnDate": this.expiryDate,
        "salesType": this.salesType,
        "secondaryAddress": {
         
        },
        "selectedPlan": {
          "planDescription": "string",
          "planId": this.planId,
          "planName": this.planName,
          "policyPdf": "",
          "questions": [
            {
              "createdAt": null,
              "createdBy": "",
              "id": 0,
              "lastModifiedBy": "",
              "plans": {
                "createdAt": null,
                "createdBy": "",
                "id": 0,
                "lastModifiedBy": "",
                "planCode": "",
                "planDescription": "",
                "planLineCode": "string",
                "planLineDescription": "string",
                "planName": this.planName,
                "policyPdf": "",
                "rate": 0,
                "updatedAt": null
              },
              "question": "string",
              "questionOptions": [
                {
                  "createdAt": null,
                  "createdBy": "",
                  "id": 0,
                  "isEligible": true,
                  "lastModifiedBy": "",
                  "option": "string",
                  "updatedAt":null
                }
              ],
              "updatedAt": null
            }
          ],
          "totalAmount": convertAmount
        },
        "startDate": this.startDate,
       
        "transactionResponse": null,
         "travellerInformation": this.travellerInfoToSend,
        // [
        //   {
        //     "age": "string",
        //     "arrivalDateOfCanada": "",
        //     "dateOfBirth": "",
        //     "eligable": true,
        //     "waitPeroid": "string"
        //   }
        // ],
        "travelllerDetails": this.travellerInfoDetailsToSend,
        "visitorsToCanada": "",
        "sslToken":this.sslToken,
        "isPayment":this.isPayment,
        "creditCardInfo": {
          "ccNum": this.ccNumber,
          "expDate": this.ssl_exp_date1
        }
      }
      // console.log(request)
      
      this.base.callPostService(this.config.changePolicy, request).subscribe((data: any) => {
        //console.log(data.data)
        if(data.status==true){
        this.blockUI.stop(); 
        window.scrollTo(0, 0);
        this.showChangePolicy=true;
        this.showChangePolicyStepOne=false;
        this.showChangePolicyStepTwo=false;
        this.showChangePolicyStepTwoB=false;
        this.showChangePolicyStepThree=false;
        this.showChangePolicyStepThreeAdminFee=false;
        this.showChangePolicyStepFour=false;
        this.showChangePolicyStepFive=true;
        this.showSearchedPolicy=false;
        this.showPolicyDetails=false;
        this.showPolicySearch=false;
        this.showRefundPolicy=false;
        this.showAudtiLogs=false;
      }
      else{
        // this.loading=false;
        this.blockUI.stop();
        Swal.fire('',data.message,'error')
      
       }
           }, error => {{
            this.blockUI.stop(); 
            if (error.status == 400) {
            }
          }
        }, () => { });
      // }
    // }
    }
    onClickChangePolicyStepFourBack(){
      window.scrollTo(0, 0);
      this.showChangePolicy=true;
      this.showChangePolicyStepOne=false;
      this.showChangePolicyStepTwo=false;
      this.showChangePolicyStepTwoB=false;
      this.showChangePolicyStepThree=false;
      this.showChangePolicyStepThreeAdminFee=true;
      this.showChangePolicyStepFour=false;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
    }
    onClickChangePolicyStepFiveNext(){
      window.scrollTo(0, 0);
      // Swal.fire('',"Successfully Sent",'success')
      this.showChangePolicy=false;
      this.showChangePolicyStepOne=false;
      this.showChangePolicyStepTwo=false;
      this.showChangePolicyStepTwoB=false;
      this.showChangePolicyStepThree=false;
      this.showChangePolicyStepThreeAdminFee=false;
      this.showChangePolicyStepFour=false;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=true;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
    }
    onClickChangePolicyStepFiveBack(){
      window.scrollTo(0, 0);
      this.showChangePolicy=true;
      this.showChangePolicyStepOne=false;
      this.showChangePolicyStepTwo=false;
      this.showChangePolicyStepTwoB=false;
      this.showChangePolicyStepThree=false;
      this.showChangePolicyStepThreeAdminFee=false;
      this.showChangePolicyStepFour=true;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
    }
    showPaymentHistoryPopup:boolean=false;
    showEditBillingInformation:boolean=false;
    onClickEditBillingInfo(){
      this.editBilling(this.policyIDDetail[0].creditCardDetails)
      this.showEditBillingInformation=true;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showAudtiLogs=false;
      this.showRefundPolicy=false;
      this.showChangePolicy=false;
    }
    backToPolicyDetails(){
      // this.showEditBillingInformation=false;
      // this.showSearchedPolicy=false;
      // this.showPolicyDetails=true;
      // this.showPolicySearch=false;
      // this.showRefundPolicy=false;
      // this.showAudtiLogs=false;
      // this.showChangePolicy=false;
      localStorage.setItem('tlSalesAdminPolicyAdmin',this.policyId)
      this.router.navigateByUrl('/dashboard/policy-details');
    }
    userPolicyDetails=[];
    policyTotal:any;
    onSelectSizePage:any=30;
    p:any=0;
    policyPageNo:any=0;
    getAllPolicyForSalesAdmin(){
      this.userservice.getAllPolicyForSalesAdmin().pipe()
      .subscribe(
          data => {
            if(data.data.userPolicyDetails.length!=0){
              this.userPolicyDetails=data.data.userPolicyDetails;
              this.policyTotal=data.data.total;
            }
          },error=>{},()=>{});
    }
    pageChnageDone(data){
      this.policyPageNo = data-1;
      this.userservice.getAllPolicyForSalesAdminByPage(this.policyPageNo,this.onSelectSizePage).pipe()
      .subscribe(
          data => {
            if(data.data.userPolicyDetails.length!=0){
              this.userPolicyDetails=data.data.userPolicyDetails;
              this.policyTotal=data.data.total;
            }
      },error=>{},()=>{});
    }
    onPolicySortAsc(data){
      this.userservice.getAllPolicyForSalesAdminSortAsc(this.policyPageNo,this.onSelectSizePage,data).pipe()
      .subscribe(
          data => {
            if(data.data.userPolicyDetails.length!=0){
              this.userPolicyDetails=data.data.userPolicyDetails;
              this.policyTotal=data.data.total;
            }
          },error=>{},()=>{});
    }
    onPolicySortDsc(data){
      this.userservice.getAllPolicyForSalesAdminSortDesc(this.policyPageNo,this.onSelectSizePage,data).pipe()
      .subscribe(
          data => {
            if(data.data.userPolicyDetails.length!=0){
              this.userPolicyDetails=data.data.userPolicyDetails;
              this.policyTotal=data.data.total;
            }
          },error=>{},()=>{});
    }
    policyIDDetail=[]
    getPolicyByIdSalesAdmin(){
      this.userservice.getPolicyByIdSalesAdmin(this.policyId).pipe()
      .subscribe(
        data => {
          
         this.policyNumber=data.data.policyNumber;
         this.purchaserAddressSame=data.data.isSameAddress
          this.startDate = data.data.effectiveDate;
          // this.startDate = new Date(this.startDate);

// // add a day
//  this.startDate.setUTCDate(this.startDate.getUTCDate() + 1);
//  this.startDate = new Date(+this.startDate);
          this.salesType = data.data.salesType;
          this.expiryDate =data.data.expiryDate;
          // this.expiryDate = new Date(this.expiryDate);

          // // add a day
          //  this.expiryDate.setUTCDate(this.expiryDate.getUTCDate() + 1);
          //  this.expiryDate = new Date(+this.expiryDate);
          this.startDate=new Date(this.startDate)
          this.expiryDate=new Date(this.expiryDate)
  // this.startDate=( new Date( this.startDate.getTime() - this.startDate.getTimezoneOffset() * -60000 )  );
  // this.expiryDate=( new Date( this.expiryDate.getTime() - this.expiryDate.getTimezoneOffset() * -60000 )  );
  this.startDate = new Date(this.startDate.getUTCFullYear(), this.startDate.getUTCMonth(), this.startDate.getUTCDate());
  this.expiryDate = new Date(this.expiryDate.getUTCFullYear(), this.expiryDate.getUTCMonth(), this.expiryDate.getUTCDate());
          this.calculatedDays = data.data.noOfDays;
          this.primaryAddress1=data.data.primaryAddress1;
          this.primaryCity =data.data.primaryAddressCity;
          this.primaryPostalCode=data.data.primaryAddressPostalCode;
          this.primaryProvince=data.data.primaryAddressProvince;
          this.purchaserAddress1 = data.data.purchaserAddress1;
          this.purchaserAddress2 = data.data.purchaserAddress2;
          this.purchaseCity = data.data.purchaserAddressCity;
          this.purchaseProvince =data.data.purchaserAddressProvince;
          if(this.purchaseProvince == "Non-Resident of Canada" || this.purchaseProvince== "Non Resident of Canada"){
            this.NonResidentSelected=true
          }else{
            this.NonResidentSelected=false; 
          }
   this.purchaserCountryName= data.data.purchaserAddressCountry;
          this.selectedQuestionlanguages1 =data.data.language;
          this.purchasePostalCode = data.data.purchaserAddressPostalCode;
          this.purchaserLastName = data.data.purchaserLastName;
          this.purchaserFirstName= data.data.purchaserFirstName;
          this.purchasePhone1 =data.data.purchaserPhone1;
          this.purchasePhone2 = data.data.purchaserPhone2;
          this.purchaseEmail =data.data.purchaserEmailAddress;
          this.purchaseEmailConfirm =data.data.purchaserEmailAddress;
          this.language=data.data.language
          this.comment =data.data.comment;
          this.beneficiary =data.data.beneficary;
          this.agentNote=data.data.agentNote;
          this.travellerInfo=data.data.policyInsureds;
          this.insuredCount =this.travellerInfo.length;
          this.NoOfInsured=data.data.policyInsureds;
          this.insuredPersonArray=data.data.policyInsureds;
          this.Tripcost=data.data.policyInsureds[0].tripCost
          // this.adminFee=data.data.transactions[0].transactionDetails[0].adminFee;
          // this.adminFeeReason=data.data.transactions[0].transactionDetails[0].adminFeeReason;
          this.PaymentPremium=data.data.policyPremium;
          this.planName=data.data.planName;
          this.planId=data.data.plans.id
          this.totalAdminFee=data.data.totalAdminFee
          this.Amount=data.data.transactions[0].transactionPaymentDetails[0].sslAmount;
          this.transactionID=data.data.transactions[0].transactionPaymentDetails[0].sslTxnId;
          this.transactionID1=data.data.transactions[0].transactionPaymentDetails[0].sslTxnId;
          this.ssl_merchant_initiated_unscheduled=data.data.transactions[0].transactionPaymentDetails[0].sslMerchantInitiatedUnscheduled;
          this.ssl_issuer_response=data.data.transactions[0].transactionPaymentDetails[0].sslIssuerResponse;
          this.ssl_partner_app_id=data.data.transactions[0].transactionPaymentDetails[0].sslPartnerAppId;
          this.ssl_card_number=data.data.transactions[0].transactionPaymentDetails[0].sslCardNumber;
          this.ssl_result=data.data.transactions[0].transactionPaymentDetails[0].sslResult;
          this.ssl_approval_code=data.data.transactions[0].transactionPaymentDetails[0].sslApprovalCode;
          this.ssl_transaction_currency=data.data.transactions[0].transactionPaymentDetails[0].sslTransactionCurrency;
          this.ssl_txn_time=data.data.transactions[0].transactionPaymentDetails[0].sslTxnTime;
          this.ssl_exp_date=data.data.transactions[0].transactionPaymentDetails[0].sslExpDate;
          this.ssl_card_short_description=data.data.transactions[0].transactionPaymentDetails[0].sslCardShortDescription;
          this.ssl_token_response=data.data.transactions[0].transactionPaymentDetails[0].sslTokenResponse;
          this.ssl_card_type=data.data.transactions[0].transactionPaymentDetails[0].sslCardType;
          this.ssl_transaction_type=data.data.transactions[0].transactionPaymentDetails[0].sslTransactionType;
          this.ssl_transaction_reference_number=data.data.transactions[0].transactionPaymentDetails[0].sslTransactionReferenceNumber;
          this.ssl_account_balance=data.data.transactions[0].transactionPaymentDetails[0].sslAccountBalance;
          this.ssl_ps2000_data=data.data.transactions[0].transactionPaymentDetails[0].sslPs2000Data;
          this.ssl_result_message=data.data.transactions[0].transactionPaymentDetails[0].sslResultMessage;
          this.ssl_cvv2_response=data.data.transactions[0].transactionPaymentDetails[0].sslCvv2Response;
          this.ssl_token=data.data.transactions[0].transactionPaymentDetails[0].sslToken;
          this.paymentTokenNew=data.data.transactions[0].transactionPaymentDetails[0].sslToken;
          this.agentId=data.data.agentId.id
          this.Tax=data.data.transactions[0].transactionPaymentDetails[0].sslSalestax;
          //this.transactionPaymentDetails=data.data.transaction[0].transactionPaymentDetails
          this.policyId=data.data.id
          this.policyIDDetail=[];
          this.policyIDDetail.push(data.data);
          this.policypaymentdetailsArray=[]
          for(let k=0;k<data.data.transactions.length;k++){
            if(data.data.transactions[k].transactionPaymentDetails[0].sslTransactionType!="RETURN"){
            this.policypaymentdetailsArray.push(data.data.transactions[k])
          }
          }
          
      },error=>{},()=>{});
    }
    onClickPolicyNumber1(){
      this.showPolicyDetails=true;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
    }
  
    showReasonError: boolean=false;
    removeRefundError(){
      this.showReasonError=false;
    }
  
    // onRefundProcessCall(){
    //   var flag = true;
    //   if(!this.refundPolicyReason)
    //   {this.showReasonError=true;flag=false}
      
    //   else{
    //     this.showReasonError=false;flag=true
    //   Swal.fire({
    //     title: 'Are you sure?',
    //     text: "you want to process the refund? ",
    //     icon: 'warning',
    //     showCancelButton: true,
    //     confirmButtonColor: '#2778c4 !important;',
    //     cancelButtonColor: '#d33',
    //     confirmButtonText: 'Yes'
    //   }).then((result) => {
    //     if (result.isConfirmed) {
          
    //       if(flag){
    //         this.userservice.refundCallApi(this.policyId,this.txnId,this.refundPolicyReason).pipe()
    //         .subscribe(
    //             data => {
    //               Swal.fire('',data.message,'success');
    //             },error=>{},()=>{});
    //       }
    //     }
    //   })
    // }
    //   // var flag = true;
    //   // if(!this.refundPolicyReason){this.showReasonError=true;flag=false}else{this.showReasonError=false;flag=true}
    //   // if(flag){
    //   //   this.userservice.refundCallApi(this.policyId,this.txnId,this.refundPolicyReason).pipe()
    //   //   .subscribe(
    //   //       data => {
    //   //         Swal.fire('',data.message,'success');
    //   //       },error=>{},()=>{});
    //   // }
    // }
  
    searchFilterPolicy(){
    this.effectiveStartDate = this.datePipe.transform(this.effectiveStartDate, "yyyy-MM-dd");
    this.departureStartDate = this.datePipe.transform(this.departureStartDate, "yyyy-MM-dd");
    this.applicationStartDate = this.datePipe.transform(this.applicationStartDate, "yyyy-MM-dd");
    this.applicationEndDate = this.datePipe.transform(this.applicationEndDate, "yyyy-MM-dd");
    
      this.userservice.getFilterSearchPolicy(this.agencyCode,this.policyNumber,this.lastName,this.firstName,this.effectiveStartDate,this.departureStartDate,this.departureEndDate,this.creditCardNumber,this.applicationStartDate,this.applicationEndDate).pipe()
        .subscribe(
            data => {
              if(data.data.searchPolicyDetails.length!=0){
                this.userPolicyDetails=[]
                this.userPolicyDetails=data.data.searchPolicyDetails;
                this.policyTotal=data.data.total;
              }
            },error=>{},()=>{});
      }
      viewCOC(){
        this.userservice.viewCOC(this.policyId).pipe()
        .subscribe(
            data => {
              
              var url=data.data
               var win = window.open(url, '_blank');
            },error=>{},()=>{});
      }
      editBilling(creditCardDetails){
        
        var cardType=creditCardDetails[0].cardType
        var id=creditCardDetails[0].id
        var sslCardNumber=creditCardDetails[0].sslCardNumber
        var sslCardShortDescription=creditCardDetails[0].sslCardShortDescription
        var sslCardType=creditCardDetails[0].sslCardType
        var sslCvv2Response=creditCardDetails[0].sslCvv2Response
        var sslExpDate=creditCardDetails[0].sslExpDate
        var sslTransactionType=creditCardDetails[0].sslTransactionType
        // cardType,id,policyId,sslCardNumber,sslCardShortDescription,sslCardType,sslCvv2Response,sslExpDate,sslTransactionType
        this.userservice.editBilling(cardType,id,this.policyId,sslCardNumber,sslCardShortDescription,sslCardType,sslCvv2Response,sslExpDate,sslTransactionType).pipe()
        .subscribe(
            data => {
              // this.editcreditCardDetails=data.data
              this.cardType=data.data.cardType
              // this.id=creditCardDetails[0].id
              this.sslCardNumber=data.data.sslCardNumber
              this.sslCardShortDescription=data.data.sslCardShortDescription
              this.sslCardType=data.data.sslCardType
              this.sslCvv2Response=data.data.sslCvv2Response
              this.sslExpDate=data.data.sslExpDate
              this.sslTransactionType=data.data.sslTransactionType
               
            },error=>{},()=>{});
      }
      onAgencyNavigation(event,data){
      if (event.ctrlKey==1){
        localStorage.setItem('agencyDetailsId', data)
        // sessionStorage.setItem('tabIndex', "document")
        //  var win = window.open('https://thzretail.com/TL/#/dashboard/edit-agencies/'+data, '_blank');
      var win = window.open('https://ua.travelance.ca/#/dashboard/edit-agencies/'+data, '_blank');
      // var win = window.open('https://mytl.travelance.ca/TL/#/dashboard/mga-details/'+data, '_blank');
    
        win.focus();
    }else{
    
      localStorage.setItem('agencyDetailsId', data)
    this.router.navigateByUrl('/dashboard/edit-agencies/'+data);
      setTimeout(() =>
       {
      location.reload();
      },
      350);
    }
  }
  onLeadNavigation(event,data){
    if (event.ctrlKey==1){
      localStorage.setItem('leadDetailsId', data);
      //  var win = window.open('https://thzretail.com/TL/#/dashboard/leads-details/'+data, '_blank');
     var win = window.open('https://ua.travelance.ca/#/dashboard/leads-details/'+data, '_blank');
  
      win.focus();
  }else{
    localStorage.setItem('leadDetailsId', data)
    // this.router.navigateByUrl('/dashboard/leads-details');
    this.router.navigateByUrl('/dashboard/leads-details/'+data);
  }
  }
      // new changes for step 2
  purchaserAddress1Flag: boolean=false;
  InsuredAdress1flag:boolean=false;
  showAddressResults1: boolean=false;
  purchaseEmailFlag:boolean=false;
  purchasePhone1Flag: boolean=false;
  purchasePostalCodeFlag:boolean=false;
  purchaseCityFlag: boolean=false;
  confirmEmailMatch: boolean=false;
  purchaserAddress1: any;
  primaryAddress1:any
  primaryAddress2:any
  primaryCity:any
  primaryPostalCode:any
  primaryProvince:any
  primaryPostalCodeFlag:boolean=false;
  primaryAddress1Flag:boolean =false;
  primaryCityFlag:boolean =false;
  primaryProvinceFlag:boolean =false;
  InsuredAddress1:any
  purchaserLastName: any;
  purchaserFirstName: any;
  purchasePostalCode: any;
  purchaseProvince: any;
  purchaseCity: any;
  purchasePhone1: any;
  purchasePhone2: any;
  purchaseEmail: any;
  purchaseEmailConfirm: any;
  adminFee:any;
  adminFeeReason:any;
  planName:any
  Amount:any
  Tax:any
  TotalBillingFee:any
  PreviousPayments:any
  transactionPaymentDetails:any=[]
  
  NoOfInsured:any
  Tripcost:any
  
  planId:any;
  PaymentPremium:any
  totalAdminFee:any
  emailNotValid: string="";
  getAddress1=[];
  getPrimaryAddress=[]
  paymentToken: any;
  transactionID: any;
  transactionID1: any;
  amount: any;
  ssl_merchant_initiated_unscheduled: any;
  ssl_issuer_response: any;
  ssl_partner_app_id: any;
  ssl_card_number1: any;
  ssl_exp_date1: any;
  ssl_cvv2_response1: any;
  ssl_card_type1: any;
  ssl_card_number: any;
  ssl_transaction_type: any;
  ssl_transaction_reference_number: any="";
  ssl_result: any;
  ssl_approval_code: any;
  ssl_txn_time: any;
  ssl_transaction_currency: any;
  ssl_account_balance: any;
  ssl_ps2000_data: any;
  ssl_exp_date: any;
  ssl_result_message: any;
  ssl_card_short_description: any;
  ssl_token_response: any;
  ssl_card_type: any;
  ssl_cvv2_response: any;
  ssl_add_token_response:any;
  ssl_avs_response:any;
  ssl_first_name:any;
  ssl_last_name:any;
  ssl_oar_data:any;
  ssl_get_token:any;
  ssl_salestax:any;
  ssl_token:any;
  ssl_avs_address:any;
  ssl_avs_zip:any;
  refundPolicyRequest:any
  payerror:boolean=false
  getPaymentTokens(){
    this.refundPolicyRequest=null
    this.payerror=false
    this.sslToken=this.paymentTokenNew
    // var obj2={}    
    //   obj2["amount"]= 0;
    //   obj2["policyId"]= 0;
    //   obj2["refundReason"]= "";
    //   obj2["txnId"]= "";
      var adminFeeAmount = this.adminFee;
      var convertAmount = this.Amount;
      while(adminFeeAmount.charAt(0) === '$')
      {
        adminFeeAmount = adminFeeAmount.substring(1);
      }
      
      adminFeeAmount=adminFeeAmount.replace (/,/g, "");
      // this.refundPolicyRequest=obj2
       var convertAmount = this.Amount;
      // if(this.Amount!=null && convertAmount.charAt(0) == '$'){
      // while(convertAmount.charAt(0) === '$')
      //    {
      //     convertAmount = convertAmount.substring(1);
      //    }
         
      //    convertAmount=convertAmount.replace (/,/g, "");
      //    convertAmount=convertAmount.replace (/$/g, "");
      //   }
      if(this.Amount!=null && this.Amount!="" && this.Amount!=undefined){
        convertAmount=convertAmount.replace (/,/g, "");
         convertAmount=convertAmount.replace ("$", "");
        }
        this.Amount=convertAmount
       var convertAmount2 = this.Amount2
      // if(this.Amount2!=null  && convertAmount2.charAt(0) == '$'){
      // while(convertAmount2.charAt(0) === '$')
      //    {
      //     convertAmount2 = convertAmount2.substring(1);
      //    }
         
      //    convertAmount2=convertAmount2.replace (/,/g, "");
      //   }
      if(this.Amount2!=null && this.Amount2!="" && this.Amount2!=undefined){
      convertAmount2=convertAmount2.replace (/,/g, "");
      convertAmount2=convertAmount2.replace ("$", "");
      }
        this.Amount2=convertAmount2
        var convertAmount3=this.Amount3
      //   if(this.Amount3!=null && convertAmount3.charAt(0) == '$'){
      // while(convertAmount3.charAt(0) === '$')
      //    {
      //     convertAmount3 = convertAmount3.substring(1);
      //    }
         
      //    convertAmount3=convertAmount3.replace (/,/g, "");
      //   }
      if(this.Amount3!=null && this.Amount3!="" && this.Amount3!=undefined){
      convertAmount3=convertAmount3.replace (/,/g, "");
      convertAmount3=convertAmount3.replace ("$", "");
      }
        this.Amount3=convertAmount3
        var convertAmount4=this.Amount4
      //   if(this.Amount4!=null && convertAmount4.charAt(0) == '$'){
      // while(convertAmount4.charAt(0) === '$')
      //    {
      //     convertAmount4 = convertAmount4.substring(1);
      //    }
         
      //    convertAmount4=convertAmount4.replace (/,/g, "");
      //   }
      if(this.Amount4!=null && this.Amount4!="" && this.Amount4!=undefined){
      convertAmount4=convertAmount4.replace (/,/g, "");
      convertAmount4=convertAmount4.replace ("$", "");
    }
        this.Amount4=convertAmount4
        var convertAmount5=this.Amount5
      //   if(this.Amount5!=null && convertAmount5.charAt(0) == '$'){
      // while(convertAmount5.charAt(0) === '$')
      //    {
      //     convertAmount5 = convertAmount5.substring(1);
      //    }
         
      //    convertAmount5=convertAmount5.replace (/,/g, "");
      //   }
      if(this.Amount5!=null && this.Amount5!="" && this.Amount5!=undefined ){
      convertAmount5=convertAmount5.replace (/,/g, "");
      convertAmount5=convertAmount5.replace ("$", "");
      }
        this.Amount5=convertAmount5
  
        // adminFeeAmount=0
  
    if(this.Amount!=null && this.cardType1 !=null){
     if(this.Amount<0){
    var negamt=this.Amount
        while(negamt.charAt(0) === '-')
           {
            negamt = negamt.substring(1);
           }
      this.refundPolicyRequest=null
      
      var obj2={}    
      obj2["amount"]= negamt;
      obj2["adminFee"]= adminFeeAmount;
      obj2["policyId"]= this.policyId;
      obj2["refundReason"]= "";
      obj2["txnId"]= this.paymentTokenNew;
       
      if(this.cardType1 !==this.ssl_card_number){
        var cardInfo={}
        cardInfo["cardNumber"]= this.CardNumber1;
        cardInfo["cvvNumber"]= this.cvv1;
        cardInfo["expiryDate"]= this.cardexpdate1;
        cardInfo["purchaserAddressPostalCode"]= this.purchasePostalCode;
        cardInfo["purchaserAddressStreet"]= this.purchaserAddress1;
        obj2["cardInfo"]=cardInfo;
      }
        
      this.refundPolicyRequest=obj2
     }
     else{
      if(this.CardNumber1!==null && this.cardexpdate1!=null ){
      this.AmounttoPay=this.Amount
      this.ssl_card_type1=this.cardType1
      this.ssl_card_number1=this.CardNumber1
      this.ssl_exp_date1=this.cardexpdate1
      // this.ssl_cvv2_response1=this.cvv1
    }
    else{
      this.payerror=true
      Swal.fire('',"Please check payment details",'error')
    }
    }
    }
    else{
     if(this.Amount!=null){
        this.payerror=true
        Swal.fire('',"Please check payment details",'error')
      }
    }
  
     if(this.Amount2!=null && this.cardType2 !=null ){
      if(this.Amount2<0){
        var negamt2=this.Amount2
        while(this.Amount2.charAt(0) === '-')
           {
            negamt2 = negamt2.substring(1);
           }
           this.refundPolicyRequest=null
        var obj2={}    
        obj2["amount"]= negamt2;
        obj2["adminFee"]= adminFeeAmount;
        obj2["policyId"]= this.policyId;
        obj2["refundReason"]= "";
        obj2["txnId"]= this.paymentTokenNew;
        if(this.cardType2 !==this.ssl_card_number){
          var cardInfo={}
          cardInfo["cardNumber"]= this.CardNumber2;
          cardInfo["cvvNumber"]= this.cvv2;
          cardInfo["expiryDate"]= this.cardexpdate2;
          cardInfo["purchaserAddressPostalCode"]= this.purchasePostalCode;
          cardInfo["purchaserAddressStreet"]= this.purchaserAddress1;
          obj2["cardInfo"]=cardInfo;
        }
        this.refundPolicyRequest=obj2
       }
       else{
        if(this.CardNumber2!==null && this.cardexpdate2!=null ){
      this.AmounttoPay=this.Amount2
      this.ssl_card_type1=this.cardType2
      this.ssl_card_number1=this.CardNumber2
      this.ssl_exp_date1=this.cardexpdate2
      // this.ssl_cvv2_response1=this.cvv2
       }
       else{
        this.payerror=true
        Swal.fire('',"Please check payment details",'error')
       }
      }
    }
    else{
      if(this.Amount2!=null){
         this.payerror=true
         Swal.fire('',"Please check payment details",'error')
       }
     }
     if(this.Amount3!=null && this.cardType3 !=null){
      if(this.Amount3<0){
        var negamt3=this.Amount3
        while(this.Amount3.charAt(0) === '-')
           {
            negamt3 = negamt3.substring(1);
           }
           this.refundPolicyRequest=null
        var obj2={}    
        obj2["amount"]= negamt3;
        obj2["adminFee"]= adminFeeAmount;
        obj2["policyId"]= this.policyId;
        obj2["refundReason"]= "";
        obj2["txnId"]= this.paymentTokenNew;
        if(this.cardType3 !==this.ssl_card_number){
          var cardInfo={}
          cardInfo["cardNumber"]= this.CardNumber3;
          cardInfo["cvvNumber"]= this.cvv3;
          cardInfo["expiryDate"]= this.cardexpdate3;
          cardInfo["purchaserAddressPostalCode"]= this.purchasePostalCode;
          cardInfo["purchaserAddressStreet"]= this.purchaserAddress1;
          obj2["cardInfo"]=cardInfo;
        }
        this.refundPolicyRequest=obj2
       }
       else{
        if(this.CardNumber3!==null && this.cardexpdate3!=null ){
      this.AmounttoPay=this.Amount3
      this.ssl_card_type1=this.cardType3
      this.ssl_card_number1=this.CardNumber3
      this.ssl_exp_date1=this.cardexpdate3
      // this.ssl_cvv2_response1=this.cvv3
    }
    else{
     this.payerror=true
     Swal.fire('',"Please check payment details",'error')
    }
   }
  }
    else{
      if(this.Amount3!=null){
         this.payerror=true
         Swal.fire('',"Please check payment details",'error')
       }
     }
     if(this.Amount4!=null && this.cardType4 !=null ){
      if(this.Amount4<0){
        var negamt4=this.Amount4
        while(this.Amount4.charAt(0) === '-')
        {
          negamt4 = negamt4.substring(1);
        }
        this.refundPolicyRequest=null
        var obj2={}    
        obj2["amount"]= negamt4;
        obj2["adminFee"]= adminFeeAmount;
        obj2["policyId"]= this.policyId;
        obj2["refundReason"]= "";
        obj2["txnId"]= this.paymentTokenNew;
        if(this.cardType4 !==this.ssl_card_number){
          var cardInfo={}
          cardInfo["cardNumber"]= this.CardNumber4;
          cardInfo["cvvNumber"]= this.cvv4;
          cardInfo["expiryDate"]= this.cardexpdate4;
          cardInfo["purchaserAddressPostalCode"]= this.purchasePostalCode;
          cardInfo["purchaserAddressStreet"]= this.purchaserAddress1;
          obj2["cardInfo"]=cardInfo;
        }
        this.refundPolicyRequest=obj2
       }
       else{
        if(this.CardNumber4!==null && this.cardexpdate4!=null ){
      this.AmounttoPay=this.Amount4
      this.ssl_card_type1=this.cardType4
      this.ssl_card_number1=this.CardNumber4
      this.ssl_exp_date1=this.cardexpdate4
      // this.ssl_cvv2_response1=this.cvv4
    }
    else{
     this.payerror=true
     Swal.fire('',"Please check payment details",'error')
    }
   }
  }
    else{
      if(this.Amount4!=null){
         this.payerror=true
         Swal.fire('',"Please check payment details",'error')
       }
     }
     if(this.Amount5!=null && this.cardType5 !=null){
      if(this.Amount5<0){
        var negamt5=this.Amount5
        while(this.Amount5.charAt(0) === '-')
        {
          negamt5 = negamt5.substring(1);
        }
        this.refundPolicyRequest=null
        var obj2={}    
        obj2["amount"]= negamt5;
        obj2["adminFee"]= adminFeeAmount;
        obj2["policyId"]= this.policyId;
        obj2["refundReason"]= "";
        obj2["txnId"]= this.paymentTokenNew;
        if(this.cardType5 !==this.ssl_card_number){
          var cardInfo={}
          cardInfo["cardNumber"]= this.CardNumber5;
          // cardInfo["cvvNumber"]= this.cvv5;
          cardInfo["expiryDate"]= this.cardexpdate5;
          cardInfo["purchaserAddressPostalCode"]= this.purchasePostalCode;
          cardInfo["purchaserAddressStreet"]= this.purchaserAddress1;
          obj2["cardInfo"]=cardInfo;
        }
        this.refundPolicyRequest=obj2
       }
       else{
        if(this.CardNumber5!==null && this.cardexpdate5!=null ){
      this.AmounttoPay=this.Amount5
      this.ssl_card_type1=this.cardType5
      this.ssl_card_number1=this.CardNumber5
      this.ssl_exp_date1=this.cardexpdate5
      // this.ssl_cvv2_response1=this.cvv5
    }
    else{
     this.payerror=true
     Swal.fire('',"Please check payment details",'error')
    }
   }
  }
    else{
      if(this.Amount5!=null){
         this.payerror=true
         Swal.fire('',"Please check payment details",'error')
       }
     }
    if(this.payerror==false){
      var s = this.Amounttotal;
      // while(s.charAt(0) === '$')
      // {
      //  s = s.substring(1);
      // }
      // console.log(s)
      //  s=s.replace (/,/g, "");
       s=s.replace (/,/g, "");
       s=s.replace ("$", "");
    
    // if(this.AmounttoPay!=null && this.ssl_card_type1 !=null && this.ssl_card_number1!==null && this.ssl_exp_date1!=null && this.ssl_cvv2_response1!=null){
      if(this.Amount==s){
    if(this.AmounttoPay!=null && this.ssl_card_type1 !=null && this.ssl_card_number1!==null && this.ssl_exp_date1!=null  ){
      this.ssl_card_number1=this.ssl_card_number1,
      this.ssl_exp_date1=this.ssl_exp_date1
      // this.ssl_cvv2_response1=this.ssl_cvv2_response1
    // this.AmounttoPay=1
      if(this.ssl_card_type1 !==this.ssl_card_number){
        this.sslToken=null
        // const request=
    //Test Cred
    // {   
     
    //     "cardExpiryDate":this.ssl_exp_date1,
    //     "cardNumber": this.ssl_card_number1,
    //      "transactiontype": "ccgettoken",
    //      "lastName": this.purchaserLastName,
    //      "firstName": this.purchaserFirstName,
    //      "purchaserAdressPostalCode": this.purchasePostalCode,
    //      "purchaserAdressStreet": this.purchaserAddress1,
    //      "amount": this.AmounttoPay,
    //      "ssl_merchant_id": "0022958",
    //      "ssl_user_id": "apiuser",
    //      "ssl_pin": "Y1R6MP4V3LN5Y3E4EPZZ4KPU8FJ2AH4DOEDG200RBA1Z7IT2T9NLBY47HB9X798S"
  //   // }
  //   {   
     
  //     "cardExpiryDate":this.ssl_exp_date1,
  //     "cardNumber": this.ssl_card_number1,
  //      "transactiontype": "ccgettoken",
  //      "lastName": this.purchaserLastName,
  //      "firstName": this.purchaserFirstName,
  //      "purchaserAdressPostalCode": this.purchasePostalCode,
  //      "purchaserAdressStreet": this.purchaserAddress1,
  //      "amount": this.AmounttoPay,
  //      "ssl_merchant_id": "2326992",
  //       "ssl_user_id": "8040326582web",
  //       "ssl_pin": "X8YW7FCTDCY9DHBGNG4NNJIHHGWDLK7ZGANOFZV75LR3LODN05DM905FOVATZKTU"
  // }    

//   this.base.callPostService(this.config.generateTokenApiForPayment, request).subscribe((data: any) => {
//       if(data.status==true){
//         this.paymentTokenNew = data.data.ssl_token;
//         this.ssl_avs_address = data.data?.ssl_avs_address;
//         this.ssl_avs_zip = data.data?.ssl_avs_zip;
      
//       }
//       else{
// // Swal.fire('',data.message);
// Swal.fire('',data.message,'error')
//       }
//          }, error => {
           
//         if (this.base.handleError(error)) {
//           if (error.status == 400) {
//           }
//         }
//       }, () => { });
  
      }
      // const request=
    //Test Cred
    // {   
    //   "transactiontype": "ccsale",
    //   "lastName":this.purchaserLastName ,
    //   "firstName": this.purchaserFirstName,
    //   "amount": this.AmounttoPay,
    //   "ssl_merchant_id": "0023039",
    //   "ssl_user_id": "apiuser",
    //   "ssl_pin": "BEC8HDPDZNJU4XBGMJOVA0Q82RF6Q05FQ4SHDJX48MXRIWFDOCD483YE5SE8DUSQ"
    // }
  
    //Prod Cred
    // {
            
    //   "transactiontype": "ccsale",
    //   "lastName": this.purchaserLastName,
    //   "firstName": this.purchaserFirstName,
    //   "amount": this.AmounttoPay,
    //   "ssl_merchant_id": "2326992",
    //   "ssl_user_id": "8040326582web",
    //   "ssl_pin": "X8YW7FCTDCY9DHBGNG4NNJIHHGWDLK7ZGANOFZV75LR3LODN05DM905FOVATZKTU"
    // }    
    // this.base.callPostService(this.config.getTokenApiForPayment, request).subscribe((data: any) => {
    //   this.paymentToken = data.data;
      this.showAddressResults1=false;
      this.paymentInfo=true
      localStorage.removeItem('selectedQuestionprovince1');
      localStorage.removeItem('selectedQuestionlanguages1');
      this.isChange=false
      // setTimeout(() =>
      // {
      //   this.paymentCall()
      // },
      // 2000);
      // setTimeout(() =>
      // {
        this.isPayment=true
         this.onClickChangePolicyStepFourNext()
      // },
      // 9000);
      
      //    }, error => {
           
      //   if (this.base.handleError(error)) {
      //     if (error.status == 400) {
      //     }
      //   }
      // }, () => { });
    }
    else{
      this.paymentInfo=false
      this.isPayment=false
      // setTimeout(() =>
      // {
      this.onClickChangePolicyStepFourNext()
      // },
      // 2000);
      // Swal.fire('',"This plan does not allow overpayments ."+ "<br>" + "Total amount entered " + "(" + this.AmounttoPay + ")"+ "does not equal" + "(" + this.Amounttotal + ")",'error')
    }
  }
  else{
    Swal.fire('',"This plan does not allow overpayments ."+ "<br>" + "Total amount entered " + "(" + this.Amount + ")"+ "does not equal" + "(" + this.Amounttotal + ")",'error')
  
  }
  }
  }
  changeFlagOnSave(){
    this.isChange=true
  }
      onClickContactInfoNext(){
        window.scrollTo(0, 0);
        var flag=true;
        
        // if(!this.form4.purchaserLastName.value){flag=true;this.purchaserLastNameFlag=true}else{flag=false;this.purchaserLastNameFlag=false}
        // if(!this.form4.purchaserFirstName.value){flag=true;this.purchaserFirstNameFlag=true}else{flag=false;this.purchaserFirstNameFlag=false}
        //if(!this.purchaserAddress1){flag=false;this.purchaserAddress1Flag=true}else{flag=true;this.purchaserAddress1Flag=false}
      //   if(!this.primaryAddress1){flag=false;this.primaryAddress1Flag=true}else{flag=true;this.primaryAddress1Flag=false}
      //   // if(!this.form4.purchaseLanguage.value){flag=false;this.purchaseLanguageFlag=true}else{flag=true;this.purchaseLanguageFlag=false}
      //  // if(!this.purchaseProvince){flag=false;this.purchaseProvinceFlag=true}else{flag=true;this.purchaseProvinceFlag=false}
      //  // if(!this.purchaseCity){flag=false;this.purchaseCityFlag=true}else{flag=true;this.purchaseCityFlag=false}
      //  // if(!this.purchasePostalCode){flag=false;this.purchasePostalCodeFlag=true}else{flag=true;this.purchasePostalCodeFlag=false}
      //   if(!this.primaryProvince){flag=false;this.primaryProvinceFlag=true}else{flag=true;this.primaryProvinceFlag=false}
      //   if(!this.primaryCity){flag=false;this.primaryCityFlag=true}else{flag=true;this.primaryCityFlag=false}
      //   if(!this.primaryPostalCode){flag=false;this.primaryPostalCodeFlag=true}else{flag=true;this.primaryPostalCodeFlag=false}
        //if(!this.purchasePhone1){flag=false;this.purchasePhone1Flag=true}else{flag=true;this.purchasePhone1Flag=false}
        // if(!this.form4.purchasePhone2.value){flag=false;this.purchasePhone2Flag=true}else{flag=true;this.purchasePhone2Flag=false}
        //if(!this.purchaseEmail){flag=false;this.purchaseEmailFlag=true;this.emailNotValid=""}else{flag=true;this.purchaseEmailFlag=false}
        // if(!this.insuredPersonArray[0].firstName){flag=false;this.firstNameFlag=true}else{flag=true;this.firstNameFlag=false}
        // if(!this.insuredPersonArray[0].lastName){flag=false;this.lastNameFlag=true}else{flag=true;this.lastNameFlag=false}
        // if(!this.insuredPersonArray[0].insitute){flag=false;this.InstituteFlag=true}else{flag=true;this.InstituteFlag=false}
        // if(!this.insuredPersonArray[0].homeCountry){flag=false;this.CountryFlag=true}else{flag=true;this.CountryFlag=false}
       
        for(let i=0;i<this.insuredPersonArray.length;i++){
          try{this.insuredPersonArray[i].firstName=this.insuredPersonArray[i].firstName.trim()}catch{}
          try{this.insuredPersonArray[i].lastName=this.insuredPersonArray[i].lastName.trim()}catch{}
          try{this.insuredPersonArray[0].insitute=this.insuredPersonArray[0].insitute.trim()}catch{}
          try{this.insuredPersonArray[0].homeCountry=this.insuredPersonArray[0].homeCountry.trim()}catch{}
          if(this.insuredPersonArray[i].firstName =="" || this.insuredPersonArray[i].firstName==null){
            this.firstNameFlag=true;flag=false
            this.insuredPersonArray[i].firstNameFlag=true
          }
          else{
            this.firstNameFlag=false;
            this.insuredPersonArray[i].firstNameFlag=false
          }
          if(this.insuredPersonArray[i].lastName =="" || this.insuredPersonArray[i].lastName==null){
            this.lastNameFlag=true;flag=false
            this.insuredPersonArray[i].lastNameFlag=true
          }
          else{
            this.lastNameFlag=false;
            this.insuredPersonArray[i].lastNameFlag=false
          }
          if(this.insuredPersonArray[0].insitute =="" || this.insuredPersonArray[0].insitute==null){
            this.InstituteFlag=true;flag=false
            this.insuredPersonArray[0].InstituteFlag=true
          }
          else{
            this.InstituteFlag=false;
            this.insuredPersonArray[0].InstituteFlag=false
          }
          if((this.insuredPersonArray[0].homeCountry =="" || this.insuredPersonArray[0].homeCountry==null) && this.NonResidentSelected==false){
            this.CountryFlag=true;flag=false
            this.insuredPersonArray[0].CountryFlag=true
          }
          else{
            this.CountryFlag=false;
            this.insuredPersonArray[0].CountryFlag=false
          }
        }
      
        if (flag == true && this.confirmEmailMatch == false ) {  
          this.showChangePolicy=true;
          this.showChangePolicyStepOne=false;
          this.showChangePolicyStepTwo=false;
          this.showChangePolicyStepTwoB=false;
          this.showChangePolicyStepThree=true;
          this.showChangePolicyStepThreeAdminFee=false;
          this.showChangePolicyStepFour=false;
          this.showChangePolicyStepFive=false;
          this.showSearchedPolicy=false;
          this.showPolicyDetails=false;
          this.showPolicySearch=false;
          this.showRefundPolicy=false;
          this.showAudtiLogs=false;  
          // this.getPaymentTokens();
          // const request={
          //   "adminFee": this.adminFee,
          //   "agentId": this.agentId,
          //   "declaration": true,
          //   "deductableOptions": [
          //     {
          //       "amount": 0,
          //       "createdAt": "2022-07-01T06:00:14.780Z",
          //       "createdBy": "string",
          //       "id": 0,
          //       "lastModifiedBy": "string",
          //       "option": "string",
          //       "reduceAmount": 0,
          //       "updatedAt": "2022-07-01T06:00:14.780Z"
          //     }
          //   ],
          //   "feeReason": this.adminFeeReason,
          //   "language": this.selectedQuestionlanguages1,
          //   "noOfDays": this.calculatedDays,
          //   "optionalInformation": {
          //     "agentNote": this.agentNote,
          //     "beneficiary":this.beneficiary,
          //     "comment": this.comment
          //   },
          //   "paymentInformation": {
          //     "amount": this.Amount,
          //     "cardNumber": this.ssl_card_number,
          //     "cardType": this.ssl_card_type,
          //     "cvv": "string",
          //     "expiryDate": this.ssl_exp_date
          //   },
          //   "paymetChangeResponse": {
          //     "amount": "string",
          //     "premimum": "string",
          //     "previousPayment": "string",
          //     "tax": "string",
          //     "totalAdminFee": this.totalAdminFee,
          //     "totalBillingFee": "string"
          //   },
          //   "policyId": this.policyId,
          //   "primaryAddress": {
          //     "address1": this.primaryAddress1,
          //     "address2": this.primaryAddress2,
          //     "city": this.primaryCity,
          //     "postalCode": this.primaryPostalCode,
          //     "province": this.primaryProvince
          //   },
          //   "purchaserAddressSame": true,
          //   "purchaserInformation": {
          //     "country": "string",
          //     "emailAddress": this.purchaseEmail,
          //     "firstName": this.purchaserFirstName,
          //     "language": this.selectedQuestionlanguages1,
          //     "lastName": this.purchaserLastName,
          //     "phoneNumber1": this.purchasePhone1,
          //     "phoneNumber2": this.purchasePhone2,
          //     "postalCode": this.purchasePostalCode,
          //     "province": this.purchaseProvince,
          //     "purchaserAddress": {
          //       "address1": this.purchaserAddress1,
          //       "address2": this.purchaserAddress2,
          //       "city": this.purchaseCity,
          //       "postalCode": this.purchasePostalCode,
          //       "province": this.purchaseProvince
          //     }
          //   },
          //   "questionsansers": [
          //     {
          //       "answer": "string",
          //       "question": "string",
          //       "quetionId": 0
          //     }
          //   ],
          //   "quoteDescriptions": "string",
          //   "quoteName": "string",
          //   "residentOf": "string",
          //   "returnDate": this.expiryDate,
          //   "salesType": "string",
          //   "secondaryAddress": {
          //     "address1": "string",
          //     "address2": "string",
          //     "city": "string",
          //     "postalCode": "string",
          //     "province": "string"
          //   },
          //   "selectedPlan": {
          //     "planDescription": "string",
          //     "planId": this.planId,
          //     "planName": this.planName,
          //     "policyPdf": "string",
          //     "questions": [
          //       {
          //         "createdAt": "2022-07-01T06:00:14.780Z",
          //         "createdBy": "string",
          //         "id": 0,
          //         "lastModifiedBy": "string",
          //         "plans": {
          //           "createdAt": "2022-07-01T06:00:14.780Z",
          //           "createdBy": "string",
          //           "id": 0,
          //           "lastModifiedBy": "string",
          //           "planCode": "string",
          //           "planDescription": "string",
          //           "planLineCode": "string",
          //           "planLineDescription": "string",
          //           "planName": "string",
          //           "policyPdf": "string",
          //           "rate": 0,
          //           "updatedAt": "2022-07-01T06:00:14.780Z"
          //         },
          //         "question": "string",
          //         "questionOptions": [
          //           {
          //             "createdAt": "2022-07-01T06:00:14.780Z",
          //             "createdBy": "string",
          //             "id": 0,
          //             "isEligible": true,
          //             "lastModifiedBy": "string",
          //             "option": "string",
          //             "updatedAt": "2022-07-01T06:00:14.780Z"
          //           }
          //         ],
          //         "updatedAt": "2022-07-01T06:00:14.780Z"
          //       }
          //     ],
          //     "totalAmount": "string"
          //   },
          //   "startDate": "string",
          //   "transactionResponse": {
          //     "ssl_account_balance":this.ssl_account_balance,
          // "ssl_add_token_response": "string",
          // "ssl_address2": "",
          // "ssl_amount": this.Amount,
          // "ssl_approval_code": this.ssl_approval_code,
          // "ssl_avs_address": "",
          // "ssl_avs_response": "",
          // "ssl_avs_zip": "",
          // "ssl_card_number": this.ssl_card_number,
          // "ssl_card_short_description": this.ssl_card_short_description,
          // "ssl_card_type":  this.ssl_card_type,
          // "ssl_city": "",
          // "ssl_company": "",
          // "ssl_completion_date": "",
          // "ssl_country": "",
          // "ssl_customer_code": "",
          // "ssl_cvv2_response": this.ssl_cvv2_response,
          // "ssl_departure_date": "",
          // "ssl_description": "",
          // "ssl_email": "",
          // "ssl_exp_date": this.ssl_exp_date,
          // "ssl_first_name": "",
          // "ssl_get_token": "",
          // "ssl_invoice_number": "",
          // "ssl_issuer_response": this.ssl_issuer_response,
          // "ssl_last_name": "",
          // "ssl_merchant_initiated_unscheduled": this.ssl_merchant_initiated_unscheduled,
          // "ssl_oar_data": "",
          // "ssl_partner_app_id": this.ssl_partner_app_id,
          // "ssl_phone": "",
          // "ssl_ps2000_data": this.ssl_ps2000_data,
          // "ssl_result": this.ssl_result,
          // "ssl_result_message": this.ssl_result_message,
          // "ssl_salestax": "",
          // "ssl_ship_to_address1": "",
          // "ssl_ship_to_zip": "",
          // "ssl_state": "",
          // "ssl_token": "",
          // "ssl_token_response": this.ssl_token_response,
          // "ssl_transaction_currency": this.ssl_transaction_currency,
          // "ssl_transaction_reference_number": this.ssl_transaction_reference_number,
          // "ssl_transaction_type": this.ssl_transaction_type,
          // "ssl_txn_id": this.transactionID,
          // "ssl_txn_time": this.ssl_txn_time
          //   },
          //   "travellerInformation": [
          //     {
          //       "age": "string",
          //       "arrivalDateOfCanada": "string",
          //       "dateOfBirth": "string",
          //       "eligable": true,
          //       "waitPeroid": "string"
          //     }
          //   ],
          //   "travelllerDetails": [
          //     {
          //       "age": "string",
          //       "arrivalDateInCanada": "string",
          //       "arrivalDateOfCanada": "string",
          //       "country": "string",
          //       "dateOfBirth": "string",
          //       "dayTimePhone": "string",
          //       "deductableOptionId": 0,
          //       "departureCity": "string",
          //       "eligable": true,
          //       "emailAddress": "string",
          //       "firstName": "string",
          //       "insitute": "string",
          //       "insuredId": 0,
          //       "language": "string",
          //       "lastName": "string",
          //       "premium": 0,
          //       "questionsansers": [
          //         {
          //           "answer": "string",
          //           "question": "string",
          //           "quetionId": 0
          //         }
          //       ],
          //       "tripCost": this.Tripcost,
          //       "waitPeroid": "string"
          //     }
          //   ],
          //   "visitorsToCanada": "string"
          // }
          // const request = 
          // {      
          //   "agentId": this.agentId,
          //   "policyId": this.policyId,
          //   "declaration": true,
          //   "deductableOptions": [
          //     {
          //       "amount": 0,
          //       "createdAt": "",
          //       "createdBy": "",
          //       "id": 0,
          //       "lastModifiedBy": "",
          //       "option": "string",
          //       "reduceAmount": 0,
          //       "updatedAt": ""
          //     }
          //   ],
          //   "language": this.selectedQuestionlanguages1,
          //   "noOfDays": this.calculatedDays,
          //   "optionalInformation": {
          //     "agentNote": this.comment,
          //     "beneficiary": this.beneficiary,
          //     "comment": this.agentNote
          //   },
          //   "paymentInformation": {
          //     "amount": 0,
          //     "cardNumber": "",
          //     "cardType": "",
          //     "cvv": "",
          //     "expiryDate": this.expiryDate
          //   },
          //   "primaryAddress": {
          //     "address1": this.primaryAddress1,
          //     "address2": this.primaryAddress2,
          //     "city": this.primaryCity,
          //     "postalCode": this.primaryPostalCode,
          //     "province": this.primaryProvince
          //   },
          //   "purchaserAddressSame": true,
          //   "questionsansers": this.questionAnsArray,
          //   "residentOf": this.selectedQuestionprovince1,
          //   "returnDate": this.expiryDate,
          //   "secondaryAddress": {
          //     "address1": "",
          //     "address2": "",
          //     "city": "",
          //     "postalCode": "",
          //     "province":""
          //   },
          //   "selectedPlan": this.selectedPlanSend,
          //   "startDate": this.startDate,
          //   "travellerInformation": this.travellerInfo,
          //   "travelllerDetails": this.insuredPersonArray,
          //   "visitorsToCanada": this.selectedQuestionAns1,
          //   "purchaserInformation":{
          //     "country": "",
          //     "emailAddress": this.purchaseEmail,
          //     "firstName": this.purchaserFirstName,
          //     "language": this.selectedQuestionlanguages1,
          //     "lastName": this.purchaserLastName,
          //     "phoneNumber1": this.purchasePhone1,
          //     "phoneNumber2": this.purchasePhone2,
          //     "postalCode": this.purchasePostalCode,
          //     "province": this.purchaseProvince,
          //     "purchaserAddress": {
          //       "address1": this.purchaserAddress1,
          //       "address2": this.purchaserAddress2,
          //       "city": this.purchaseCity,
          //       "postalCode": this.purchasePostalCode
          //   }}
          //  }
          // this.restService.callPostService(this.config.postApistep3, request).subscribe((data: any) => {
       // this.base.callPostService(this.config.postApistep3, request).subscribe((data: any) => {
          // window.scrollTo(0, 0);
          // this.showChangePolicy=true;
          // this.showChangePolicyStepOne=false;
          // this.showChangePolicyStepTwo=true;
          // this.showChangePolicyStepTwoB=false;
          // this.showChangePolicyStepThree=true;
          // this.showChangePolicyStepThreeAdminFee=false;
          // this.showChangePolicyStepFour=false;
          // this.showChangePolicyStepFive=false;
          // this.showSearchedPolicy=false;
          // this.showPolicyDetails=false;
          // this.showPolicySearch=false;
          // this.showRefundPolicy=false;
        //this.step2SaveApiCall()
        // if(this.intStudPlanChecked==true || this.intStudPlanChecked1==true){
        //   this.showQuestionnaireQue=false;
        //   this.showDeclarationQuestionnaire=false;
        //   this.showChooseQuote=false;
        //   this.showIntStudPlan=true;
        //   this.showIntStudPlanStep1=false;
        //   this.showIntStudPlanPlanOption=false;
        //   this.showQuestionnaire=false;
        //   this.showQuestionnaireQue=false;
        //   this.showContactInfo=false;
        //   this.showPayment=true;
        //   this.showPaymentsDetails=false;
        // }
        // if(this.studAccidentIncChecked==true){
        //   this.showQuestionnaireQue=false;
        //   this.showDeclarationQuestionnaire=false;
        //   this.showChooseQuote=false;
        //   this.showIntStudPlan=true;
        //   this.showIntStudPlanStep1=false;
        //   this.showIntStudPlanPlanOption=false;
        //   this.showQuestionnaire=false;
        //   this.showQuestionnaireQue=false;
        //   this.showContactInfo=false;
        //   this.showPayment=true;
        //   this.showPaymentsDetails=false;
        // }
        //this.paymentCall();
        // this.step2SaveApiCall()
          // localStorage.removeItem('selectedQuestionprovince1');
          // localStorage.removeItem('selectedQuestionlanguages1');
          // setTimeout(() =>
          // {
          // this.finalStageTransactionCall();
          // },
          // 8000);
            //  }, error => {{
            //   if (error.status == 400) {
            //   }
            // }
       //   }, () => { });
        } 
        
       }
     
  purchaseProvinceFlag: boolean=false;
  NonResidentSelected: boolean=false;
  purchaserLastNameFlag: boolean=false;
  purchaserFirstNameFlag: boolean=false;
  comment: any;
  beneficiary: any;
  agentNote: any;
  onProvinceClick(){
    this.purchaseProvinceFlag=false;
    if(this.purchaseProvince == "Non-Resident of Canada" || this.purchaseProvince== "Non Resident of Canada"){
      this.NonResidentSelected=true
    }else{
      this.NonResidentSelected=false; 
    }
    }
    insuredPersonArray=[];  
    insuredPerson(){
      var obj={};
      obj["firstName"]=""
      obj["lastName"]=""
      obj["insitute"]=""
      obj["homeCountry"]="" 
      this.insuredPersonArray.push(obj);
    }
    declarationErrorFlag: boolean=true;
    onClickDeclaration(event){
      var flagCheck = event.target.checked;
      if(flagCheck==true){
      this.declarationErrorFlag=false;
      }else{
        this.declarationErrorFlag=true;
      
      }
          }
      
    step2SaveApiCall(){
      
      var flag=true;
      if(this.declarationErrorFlag == true){flag=false; this.declarationErrorFlag=true}else{this.declarationErrorFlag=false}
      //flag=true;
      if(flag){
      if(this.travellerInfo.length==2){
        
        this.insuredPerson();
      }
      if(this.travellerInfo.length==3){
        this.insuredPerson();
        this.insuredPerson();
      }
      if(this.travellerInfo.length==4){
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
      }
      if(this.travellerInfo.length==5){
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
      }
      if(this.travellerInfo.length==6){
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
      }
      if(this.travellerInfo.length==7){
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
      }
      if(this.travellerInfo.length==8){
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
      }
      if(this.travellerInfo.length==9){
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
      }
        if (flag == true) {
          for(let i=0;i<this.travellerInfo.length;i++){
            var obj={}    
          
            obj["age"]= this.travellerInfo[i].age;
            obj["arrivalDateInCanada"]= this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd");
            obj["arrivalDateOfCanada"]= this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd");
            obj["country"]=  this.travellerInfo[i].homeCountry;
            obj["dateOfBirth"]= this.travellerInfo[i].dateOfBirth;
            obj["dayTimePhone"]= ""
            obj["deductableOptionId"]= ""
            obj["departureCity"]= this.travellerInfo[i].homeCountry;
            obj["eligable"]= "true"
            obj["emailAddress"]= ""
            obj["firstName"]= this.travellerInfo[i].firstName;
            obj["insitute"]= this.travellerInfo[i].insitute
            obj["language"]= this.language
            obj["lastName"]= this.travellerInfo[i].lastName;
            obj["premium"]= 0;
            obj["questionsansers"]=[]
            obj["tripCost"]= 0
            obj["insuredId"]=this.travellerInfo[i].id
            obj["waitPeroid"]= this.travellerInfo[i].waitPeroid;
            this.travellerInfoDetailsToSend.push(obj)
            }
          const request = 
          { 
            "agentId": this.agentId,
            "declaration": true,
            "deductableOptions": [
              {
                "amount": 0,
                "createdAt": "",
                "createdBy": "",
                "id": 0,
                "lastModifiedBy": "",
                "option": "",
                "reduceAmount": 0,
                "updatedAt": ""
              }
            ],
            "language": this.selectedQuestionlanguages1,
            "noOfDays": this.calculatedDays,
            "optionalInformation": {
              "agentNote": this.agentNote,
              "beneficiary": this.beneficiary,
              "comment": this.comment
            },
            "paymentInformation": {
              "amount": 0,
              "cardNumber": "",
              "cardType": "",
              "cvv": "",
              "expiryDate": ""
            },
            "primaryAddress": {
              "address1": this.primaryAddress1,
              "address2": this.primaryAddress2,
              "city": this.primaryCity,
              "postalCode": this.primaryPostalCode,
              "province":this.primaryProvince
            },
            "isSameAddress": this.purchaserAddressSame,
            "questionsansers": "",
            "residentOf": this.purchaseProvince,
            "returnDate": this.expiryDate,
            "secondaryAddress": {
              "address1": "",
              "address2": "",
              "city": "",
              "postalCode": "",
              "province":""
            },
            "selectedPlan": this.selectedPlanSend,
            "startDate": this.startDate,
            "travellerInformation": this.travellerInfo,
            "travelllerDetails": this.travellerInfoDetailsToSend,
            "visitorsToCanada": this.selectedQuestionAns1,
            "purchaserInformation":{
              "country": "",
              "emailAddress": this.purchaseEmail,
              "firstName": this.purchaserFirstName,
              "language": "",
              "lastName":this.purchaserLastName,
              "phoneNumber1": this.purchasePhone1,
              "phoneNumber2": this.purchasePhone2,
              "postalCode": this.purchasePostalCode,
              "province": this.purchaseProvince,
              "purchaserAddress": {
                "address1": this.purchaserAddress1,
                "address2": this.purchaserAddress2,
                "city": this.purchaseCity,
                "postalCode":this.purchasePostalCode
            }}
           }
            this.base.callPostService(this.config.postApistep2, request).subscribe((data: any) => {
              
              this.onClickQuestionnaireProceed();
             }, error => {
        
          }, () => { });
        }
      }
    }
  
    questionAnsArray: any[]=[];
    selectedPlanSend=[];
    onClickQuestionnaireProceed(){
      window.scrollTo(0, 0);
  
    }
    onCityClick(){
      this.purchaseCityFlag=false;
      }
      onEmailClick(){
        this.purchaseEmailFlag=false;  
        }
        onPhoneClick1(){
        this.purchasePhone1Flag=false;
        }
        onPostalCodeClick(){
        this.purchasePostalCodeFlag=false;
        }
        callAddressApiCall1(){
          this.purchaserAddress1Flag=false;
          this.showAddressResults1=true;
          // this.purchaseProvince=false;
          // this.purchasePostalCode=false;
          // this.purchaseCity=false;
          this.user.getAddressCanada(this.purchaserAddress1).subscribe((data:any) =>{
           this.getAddress1 = data.suggestions;
          },error=>{{
          //handle Exception from Server 404,401
          }},()=>{});
        }
        callAddressApiCall1N(){
          this.purchaserAddress1Flag=false;
          this.showAddressResults1=true;
          // this.purchaseProvince=false;
          // this.purchasePostalCode=false;
          // this.purchaseCity=false;
          this.user.getAddressCanada1N(this.purchaserAddress1,this.purchaserAddress1c).subscribe((data:any) =>{
           this.getAddress1 = data.Items;
          },error=>{{
          //handle Exception from Server 404,401
          }},()=>{});
        }
        callAddressApiCall(){
          this.showcheckbox=false;
          this.primaryAddress1Flag=false;
          this.showAddressResults1=true;
          // this.primaryProvince=false;
          // this.primaryPostalCode=false;
          // this.primaryCity=false;
          this.user.getAddressCanada1(this.primaryAddress1).subscribe((data:any) =>{
           this.getPrimaryAddress = data.suggestions;
          },error=>{{
          //handle Exception from Server 404,401
          }},()=>{});
        }
        callAddressApiCallN(){
          this.primaryAddress1Flag=false;
          this.showAddressResults1=true;
          // this.primaryProvince=false;
          // this.primaryPostalCode=false;
          // this.primaryCity=false;
          this.user.getAddressCanadaN(this.primaryAddress1,this.primaryAddress1c).subscribe((data:any) =>{
           this.getPrimaryAddress = data.Items;
          },error=>{{
          //handle Exception from Server 404,401
          }},()=>{});
        }
        getSelectedAddress1: any[]=[];
    onClickSearchResult1(item){

      // if(item.Type== "Address"){
    this.purchaserAddress1=item.Text;
    this.showAddressResults1=false;
    this.user.getAddressCanadaSelected(item.action.id).subscribe((data:any) =>{
      this.getSelectedAddress1 = data.features;
      this.purchaserAddress1=this.getSelectedAddress1[0]?.properties?.address_line1;
      this.purchaserAddress2=this.getSelectedAddress1[0]?.properties?.address_line2;
      this.purchaseCity=this.getSelectedAddress1[0]?.properties?.place;
      this.purchasePostalCode=this.getSelectedAddress1[0]?.properties?.postcode;
      this.purchaseProvince=this.getSelectedAddress1[0]?.properties?.region;
      if(this.getSelectedAddress1[0]?.properties?.region=="Québec"){
        this.getSelectedAddress1[0].properties.region="Quebec"
        this.purchaseProvince=this.getSelectedAddress1[0]?.properties?.region;
      }else{
        this.purchaseProvince=this.getSelectedAddress1[0]?.properties?.region;
      }
      // this.purchaseCityFlag=false;
      // this.purchasePostalCodeFlag=false;
      // this.purchaseProvinceFlag=false;
     },error=>{{
     }},()=>{})
    // }
    // else{
    //   this.purchaserAddress1=item.Text;
    //   this.purchaserAddress1c=item.Id;
    //   this.callAddressApiCall1N();
    // }
   
  }
  getSelectedAddress2: any[]=[];
  onClickSearchResultprimary(item){
    // if(item.Type== "Address"){
    this.primaryAddress1=item.Text;
    this.showAddressResults1=false;
    this.showcheckbox=true;
    this.user.getAddressCanadaSelected(item.action.id).subscribe((data:any) =>{
      this.getSelectedAddress2 = data.features;
      this.primaryAddress1=this.getSelectedAddress2[0]?.properties?.address_line1;
      this.primaryAddress2=this.getSelectedAddress2[0]?.properties?.address_line2;
      this.primaryCity=this.getSelectedAddress2[0]?.properties?.place;
      this.primaryPostalCode=this.getSelectedAddress2[0]?.properties?.postcode;
      this.primaryProvince=this.getSelectedAddress2[0]?.properties?.region;
      // this.purchaseCityFlag=false;
      // this.purchasePostalCodeFlag=false;
      // this.purchaseProvinceFlag=false;
     },error=>{{
     }},()=>{})
    // }
    // else{
    //   this.primaryAddress1=item.Text;
    //   this.primaryAddress1c=item.Id
    //   this.callAddressApiCallN()
    // }
  }
  provincesArray:any[]=[];
  getAllProvinces(){
    this.user.getProvincesBToB().subscribe((data:any) =>{
     this.provincesArray = data.data;
    },error=>{{
    }},()=>{});
  }
  // onSaveQuote3(){
  //   var flag=true;
  //   if(!this.quoteName){this.quoteNameFlag=true;flag=false}else{this.quoteNameFlag=false;flag=true}  
  //   if (flag == true) {    
  //     const request = 
  //     {      
  //       "agentId": this.agentId,
  //       "declaration": true,
  //       "deductableOptions": [
  //         {
  //           "amount": 0,
  //           "createdAt": "2022-04-27T05:08:15.125Z",
  //           "createdBy": "string",
  //           "id": 0,
  //           "lastModifiedBy": "string",
  //           "option": "string",
  //           "reduceAmount": 0,
  //           "updatedAt": "2022-04-27T05:08:15.125Z"
  //         }
  //       ],
  //       "language": this.selectedQuestionlanguages1,
  //       "noOfDays": this.calculatedDays,
  //       "optionalInformation": {
  //         "agentNote": this.comment,
  //         "beneficiary": this.beneficiary,
  //         "comment": this.agentNote
  //       },
  //       "paymentInformation": {
  //         "amount": 0,
  //         "cardNumber": "string",
  //         "cardType": "string",
  //         "cvv": "string",
  //         "expiryDate": "string"
  //       },
  //       "primaryAddress": {
  //         "address1": "",
  //         "address2": "",
  //         "city": "",
  //         "postalCode": "",
  //         "province": ""
  //       },
  //       "quoteDescriptions": this.quoteDescriptions,
  //       "quoteName": this.quoteName,
  //       "purchaserAddressSame": true,
  //       "questionsansers": this.questionAnsArray,
  //       "residentOf": this.selectedQuestionprovince1,
  //       "returnDate": this.expiryDate,
  //       "secondaryAddress": {
  //         "address1": "string",
  //         "address2": "string",
  //         "city": "string",
  //         "postalCode": "string",
  //         "province":"string"
  //       },
  //       "selectedPlan": this.selectedPlanSend,
  //       "startDate": this.startDate,
  //       "travellerInformation": this.travellerInfo,
  //       "travelllerDetails": this.insuredPersonArray,
  //       "visitorsToCanada": this.selectedQuestionAns1,
  //       "purchaserInformation":{
  //         "country": "",
  //         "emailAddress": this.purchaseEmail,
  //         "firstName": this.purchaserFirstName,
  //         "language": this.selectedQuestionlanguages1,
  //         "lastName": this.purchaserLastName,
  //         "phoneNumber1": this.purchasePhone1,
  //         "phoneNumber2": this.purchasePhone2,
  //         "postalCode": this.purchasePostalCode,
  //         "province": this.purchaseProvince,
  //         "purchaserAddress": {
  //           "address1": this.purchaserAddress1,
  //           "address2": this.purchaserAddress2,
  //           "city": this.purchaseCity,
  //           "postalCode": this.purchasePostalCode
  //       }}
  //      }
  //   this.base.callPostService(this.config.saveQuote, request).subscribe((data: any) => {
  //     this.quoteNameFlag=false;
  //     this.saveQuotesPopup=false;
  //     this.saveQuotesPopup1=false;
  //     this.saveQuotesPopup2=false;
  //     this.quoteName="";
  //     this.quoteDescriptions=""
  //     Swal.fire('',"Quote information saved.",'success');
     
  //        }, error => {{
  //         if (error.status == 400) {
  //         }
  //       }
  //     }, () => { });
  //   } 
    
  //  }
  popUpLanguageFlag:boolean=false;
  validateLanguage(data){
    if(data != null){
      this.popUpLanguageFlag=true;
    }
  }
  languagesArray: any=[];
  getAllLanguages(){
    this.user.getLanguageBToB().subscribe((data:any) =>{
     this.languagesArray = data.data;
    },error=>{{
    }},()=>{});
  }
  notValidPhoneNo: string="";
  checkPatternWork(){  
    var re = /^[0-9-+() ]*$/;
    if (!re.test(this.purchasePhone1.toLowerCase())) {
    this.notValidPhoneNo="Please enter valid Work Phone";
    }else{
      this.notValidPhoneNo=""
    }
    }
    checkConfirmEmail(){
      if(this.purchaseEmail && this.purchaseEmailConfirm){
        if(this.purchaseEmail==this.purchaseEmailConfirm){
          this.confirmEmailMatch = false;
        }else{
          this.confirmEmailMatch = true;
        }
      }
      
    }
    emailCheck(){
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(this.purchaseEmail.toLowerCase())){
        this.emailNotValid="Please enter valid Email";
      }else{
        this.emailNotValid="";
      }
      }
      printPopup:boolean=false;
      viewPaymentDetailsPopup:boolean=false;
      newNotePopup:boolean=false;
      email:any=[];
      email1:any;
      email2:any;
      emailErrorFlag:boolean=false;
      onRemoveEmailError(){
        this.emailErrorFlag=false;
        }
      
      onSendEmail(){
        this.blockUI.start();
        this.email=[];
        if(!this.email1){this.emailErrorFlag=true}else{this.emailErrorFlag=false}
        if(this.emailErrorFlag==false){
          this.printPopup=false;
          this.email.push(this.email1)
          // this.email.push(this.email2)
        this.userservice.getPolicyEmailSend(this.email,this.policyId).pipe().subscribe(data => {
          // Swal.fire('','Email sent successfully.','success');
          if(data){
          this.blockUI.stop();
          Swal.fire({
           
            text: "Email sent successfully.",
            icon: 'success',
           
            confirmButtonColor: '#3085d6',
           
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
              this.email1="";
              localStorage.setItem('tlSalesAdminPolicyAdmin',this.policyId)
          this.router.navigateByUrl('/dashboard/policy-details');
            }
            // else{
            //   this.pdfmodel2 = !this.pdfmodel2;
            // }
          })
        }
          },error=>{
          },()=>{});
      }
    }
    returnHome(){
      this.email1="";
      localStorage.setItem('tlSalesAdminPolicyAdmin',this.policyId)
  this.router.navigateByUrl('/dashboard/policy-details');
    }
      editEffectiveDate:boolean=false;
      editContactInfoName:boolean=false;
      editContactInfoAdderss:boolean=false;
      editContactInfoEmail:boolean=false;
      editContactInfoLanguage:boolean=false;
      editPurchaserInfoName:boolean=false;
      editPurchaserInfoAddress:boolean=false;
      editPurchaserInfoEmail:boolean=false;
      editPurchaserInfoPhoneOne:boolean=false;
      editPurchaserInfoPhoneTwo:boolean=false;
      editPurchaserInfoLanguage:boolean=false;
      updateEffectiveDate(){
        this.editEffectiveDate =! this.editEffectiveDate;
      }
      updateContactInfoName(){
        this.editContactInfoName =! this.editContactInfoName;
      }
      updateContactInfoAdderss(){
        this.editContactInfoAdderss=!this.editContactInfoAdderss;
      }
      updateContactInfoEmail(){
        this.editContactInfoEmail=!this.editContactInfoEmail;
      }
      updateContactInfoLanguage(){
        this.editContactInfoLanguage=!this.editContactInfoLanguage;
      }
      updatePurchaserInfoName(){
        this.editPurchaserInfoName=!this.editPurchaserInfoName;
      }
      updatePurchaserInfoAddress(){
        this.editPurchaserInfoAddress=!this.editPurchaserInfoAddress;
      }
      updatePurchaserInfoEmail(){
        this.editPurchaserInfoEmail=!this.editPurchaserInfoEmail;
      }
      updatePurchaserInfoPhoneOne(){
        this.editPurchaserInfoPhoneOne=!this.editPurchaserInfoPhoneOne;
      }
      updatePurchaserInfoPhoneTwo(){
        this.editPurchaserInfoPhoneTwo=!this.editPurchaserInfoPhoneTwo;
      }
      updatePurchaserInfoLanguage(){
        this.editPurchaserInfoLanguage=!this.editPurchaserInfoLanguage;
      }
      onLogsDetails(){
        // this.showChangePolicy=false;
        // this.showChangePolicyStepOne=false;
        // this.showChangePolicyStepTwo=false;
        // this.showChangePolicyStepTwoB=false;
        // this.showChangePolicyStepThree=false;
        // this.showChangePolicyStepThreeAdminFee=false;
        // this.showChangePolicyStepFour=false;
        // this.showChangePolicyStepFive=false;
        // this.showSearchedPolicy=false;
        // this.showPolicyDetails=false;
        // this.showPolicySearch=false;
        // this.showRefundPolicy=false;
        // this.showAudtiLogs=true;
        this.router.navigateByUrl('/dashboard/policy-audit-logs');
      }
      noteText:any;
      noteType:any;
      addNotesToPolicy(){
        this.newNotePopup=false;
        this.userservice.addNoteInPolicy(this.noteText,this.policyId,this.noteType).pipe().subscribe(data => {
          
          },error=>{
            this.newNotePopup=false;
          },()=>{});
    }
     PaymentType:any
     expDate1ToSend:any
     expDateYearToSend:any
     cardexpdate1Flag:boolean=false
     cardexpdate2Flag:boolean=false
     cardexpdate3Flag:boolean=false
     cardexpdate4Flag:boolean=false
     cardexpdate5Flag:boolean=false
     cardexpdateFlagButtonDisable:boolean=false
        changePaymentType(a){
           
         if(a==null){
           this.cardType1=""
           this.CardNumber1=""
           this.cardexpdate1=""
           this.showCardNo1=false
           this.showCVV1=false
           this.showexp1=false
         }
         // if(a==this.ssl_card_number || a==""){
         //   this.cardType1=this.ssl_card_number
         //   // this.CardNumber1=ct
         //   this.cardexpdate1=this.ssl_exp_date
         if(a.id){
           
           // if(a==this.ssl_card_number || a==""){
           this.cardType1=a.transactionPaymentDetails[0].sslCardNumber
           this.ssl_card_number=a.transactionPaymentDetails[0].sslCardNumber
       // this.cardType1=this.ssl_card_number
       // this.CardNumber1=ct
       // this.cardexpdate1=this.ssl_exp_date
       this.cardexpdate1=a.transactionPaymentDetails[0].sslExpDate
       
       this.expDate1ToSend=this.cardexpdate1.substring(0, 2);
       this.expDateYearToSend=this.cardexpdate1.substring(2, 4)
       
      
       const d = new Date();
       let month = getMonth(d);
       function getMonth(date) {
         var month = date.getMonth() + 1;
         return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
       }  
       
       const last2 = new Date().getFullYear().toString().slice(-2);
       console.log(last2); // 👉️ has type of string
       const last2Num = Number(last2);
       
         console.log(month)
         console.log(last2Num)
         console.log(this.expDate1ToSend)
         console.log(this.expDateYearToSend)
         if(this.expDateYearToSend<last2Num)
         {
           this.cardexpdate1Flag=true
           this.cardexpdateFlagButtonDisable=true
         }
         else{
       if(this.expDate1ToSend<month && this.expDateYearToSend<=last2Num)
       {
         // localStorage.removeItem('responseID');
         // // this.blockUI.stop()
         // Swal.fire('',"Expiry Date Invalid.",'error')
         this.cardexpdate1Flag=true
         this.cardexpdateFlagButtonDisable=true
       }
       this.cardexpdate1Flag=false
       this.cardexpdateFlagButtonDisable=false
     }
       this.txnId = a.transactionPaymentDetails[0].sslTxnId;
       this.paymentTokenNew=a.transactionPaymentDetails[0].sslToken;
         this.showCardNo1=false
         this.showCVV1=false
         this.showexp1=true
         }
         else{
           this.showCVV1=true
           this.showCardNo1=true
           this.showexp1=true
         }
       }
       
       changePaymentType2(a){
         
         if(a==null){
           this.cardType2=""
           this.CardNumber2=""
           this.cardexpdate2=""
           this.showCardNo2=false
           this.showCVV2=false
           this.showexp2=false
         }
         if(a.id){
           // if(a==this.ssl_card_number || a==""){
           this.cardType2=a.transactionPaymentDetails[0].sslCardNumber
           this.ssl_card_number=a.transactionPaymentDetails[0].sslCardNumber
       // this.cardType1=this.ssl_card_number
       // this.CardNumber1=ct
       // this.cardexpdate1=this.ssl_exp_date
       this.cardexpdate2=a.transactionPaymentDetails[0].sslExpDate
     
       this.expDate1ToSend=this.cardexpdate1.substring(0, 2);
       this.expDateYearToSend=this.cardexpdate1.substring(2, 4)
       
      
       const d = new Date();
       let month = getMonth(d);
       function getMonth(date) {
         var month = date.getMonth() + 1;
         return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
       }  
       
       const last2 = new Date().getFullYear().toString().slice(-2);
       console.log(last2); // 👉️ has type of string
       const last2Num = Number(last2);
       
         console.log(month)
         console.log(last2Num)
         console.log(this.expDate1ToSend)
         console.log(this.expDateYearToSend)
         if(this.expDateYearToSend<last2Num)
         {
           this.cardexpdate2Flag=true
           this.cardexpdateFlagButtonDisable=true
         }
         else{
       if(this.expDate1ToSend<month && this.expDateYearToSend<=last2Num)
       {
         // localStorage.removeItem('responseID');
         // // this.blockUI.stop()
         // Swal.fire('',"Expiry Date Invalid.",'error')
         this.cardexpdate2Flag=true
         this.cardexpdateFlagButtonDisable=true
       }
       this.cardexpdate2Flag=false
       this.cardexpdateFlagButtonDisable=false
     }
     
     
       this.txnId = a.transactionPaymentDetails[0].sslTxnId;
       this.paymentTokenNew=a.transactionPaymentDetails[0].sslToken;
           this.showCardNo2=false
           this.showCVV2=false
           this.showexp2=true
         }
         else{
           this.showCVV2=true
           this.showCardNo2=true
           this.showexp2=true
         }
       }
       changePaymentType3(a){
         if(a==null){
           this.cardType3=""
           this.CardNumber3=""
           this.cardexpdate3=""
           this.showCardNo3=false
           this.showCVV3=false
           this.showexp3=true
         }
         if(a.id){
           // if(a==this.ssl_card_number || a==""){
           this.cardType3=a.transactionPaymentDetails[0].sslCardNumber
           this.ssl_card_number=a.transactionPaymentDetails[0].sslCardNumber
       // this.cardType1=this.ssl_card_number
       // this.CardNumber1=ct
       // this.cardexpdate1=this.ssl_exp_date
       this.cardexpdate3=a.transactionPaymentDetails[0].sslExpDate
     
     
       this.expDate1ToSend=this.cardexpdate1.substring(0, 2);
       this.expDateYearToSend=this.cardexpdate1.substring(2, 4)
       
      
       const d = new Date();
       let month = getMonth(d);
       function getMonth(date) {
         var month = date.getMonth() + 1;
         return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
       }  
       
       const last2 = new Date().getFullYear().toString().slice(-2);
       console.log(last2); // 👉️ has type of string
       const last2Num = Number(last2);
       
         console.log(month)
         console.log(last2Num)
         console.log(this.expDate1ToSend)
         console.log(this.expDateYearToSend)
         if(this.expDateYearToSend<last2Num)
         {
           this.cardexpdate3Flag=true
           this.cardexpdateFlagButtonDisable=true
         }
         else{
       if(this.expDate1ToSend<month && this.expDateYearToSend<=last2Num)
       {
         // localStorage.removeItem('responseID');
         // // this.blockUI.stop()
         // Swal.fire('',"Expiry Date Invalid.",'error')
         this.cardexpdate3Flag=true
         this.cardexpdateFlagButtonDisable=true
       }
       this.cardexpdate3Flag=false
       this.cardexpdateFlagButtonDisable=false
     }
       this.txnId = a.transactionPaymentDetails[0].sslTxnId;
       this.paymentTokenNew=a.transactionPaymentDetails[0].sslToken;
           this.showCardNo3=false
           this.showCVV3=false
           this.showexp3=true
         }
         else{
           this.showCVV3=true
           this.showCardNo3=true
           this.showexp3=true
         }
       }
       changePaymentType4(a){
         if(a==null){
           this.cardType4=""
           this.CardNumber4=""
           this.cardexpdate4=""
           this.showCardNo4=false
           this.showCVV4=false
           this.showexp4=false
         }
         if(a.id){
           // if(a==this.ssl_card_number || a==""){
           this.cardType4=a.transactionPaymentDetails[0].sslCardNumber
           this.ssl_card_number=a.transactionPaymentDetails[0].sslCardNumber
       // this.cardType1=this.ssl_card_number
       // this.CardNumber1=ct
       // this.cardexpdate1=this.ssl_exp_date
       this.cardexpdate4=a.transactionPaymentDetails[0].sslExpDate
     
       this.expDate1ToSend=this.cardexpdate1.substring(0, 2);
       this.expDateYearToSend=this.cardexpdate1.substring(2, 4)
       
      
       const d = new Date();
       let month = getMonth(d);
       function getMonth(date) {
         var month = date.getMonth() + 1;
         return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
       }  
       
       const last2 = new Date().getFullYear().toString().slice(-2);
       console.log(last2); // 👉️ has type of string
       const last2Num = Number(last2);
       
         console.log(month)
         console.log(last2Num)
         console.log(this.expDate1ToSend)
         console.log(this.expDateYearToSend)
         if(this.expDateYearToSend<last2Num)
         {
           this.cardexpdate4Flag=true
           this.cardexpdateFlagButtonDisable=true
         }
         else{
       if(this.expDate1ToSend<month && this.expDateYearToSend<=last2Num)
       {
         // localStorage.removeItem('responseID');
         // // this.blockUI.stop()
         // Swal.fire('',"Expiry Date Invalid.",'error')
         this.cardexpdate4Flag=true
         this.cardexpdateFlagButtonDisable=true
       }
       this.cardexpdate4Flag=false
       this.cardexpdateFlagButtonDisable=false
     }
       this.txnId = a.transactionPaymentDetails[0].sslTxnId;
       this.paymentTokenNew=a.transactionPaymentDetails[0].sslToken;
           this.showCardNo4=false
           this.showCVV4=false
           this.showexp4=true
         }
         else{
           this.showCVV4=true
           this.showCardNo4=true
           this.showexp4=true
         }
       }
       changePaymentType5(a){
         if(a==null){
           this.cardType5=""
           this.CardNumber5=""
           this.cardexpdate5=""
           this.showCardNo5=false
           this.showCVV5=false
           this.showexp5=false
         }
         if(a.id){
           // if(a==this.ssl_card_number || a==""){
           this.cardType5=a.transactionPaymentDetails[0].sslCardNumber
           this.ssl_card_number=a.transactionPaymentDetails[0].sslCardNumber
       // this.cardType1=this.ssl_card_number
       // this.CardNumber1=ct
       // this.cardexpdate1=this.ssl_exp_date
       this.cardexpdate5=a.transactionPaymentDetails[0].sslExpDate
       this.expDate1ToSend=this.cardexpdate1.substring(0, 2);
       this.expDateYearToSend=this.cardexpdate1.substring(2, 4)
       
      
       const d = new Date();
       let month = getMonth(d);
       function getMonth(date) {
         var month = date.getMonth() + 1;
         return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
       }  
       
       const last2 = new Date().getFullYear().toString().slice(-2);
       console.log(last2); // 👉️ has type of string
       const last2Num = Number(last2);
       
         console.log(month)
         console.log(last2Num)
         console.log(this.expDate1ToSend)
         console.log(this.expDateYearToSend)
         if(this.expDateYearToSend<last2Num)
         {
           this.cardexpdate5Flag=true
           this.cardexpdateFlagButtonDisable=true
         }
         else{
       if(this.expDate1ToSend<month && this.expDateYearToSend<=last2Num)
       {
         // localStorage.removeItem('responseID');
         // // this.blockUI.stop()
         // Swal.fire('',"Expiry Date Invalid.",'error')
         this.cardexpdate5Flag=true
         this.cardexpdateFlagButtonDisable=true
       }
       this.cardexpdate5Flag=false
       this.cardexpdateFlagButtonDisable=false
     }
       this.txnId = a.transactionPaymentDetails[0].sslTxnId;
       this.paymentTokenNew=a.transactionPaymentDetails[0].sslToken;
           this.showexp5=true
           this.showCardNo5=false
           this.showCVV5=false
         }
         else{
           this.showCVV5=true
           this.showCardNo5=true
           this.showexp5=true
         }
         
       }
  
    onClickPurchaseInfoNext(){
      window.scrollTo(0, 0);
      var flag=true;
      try{this.purchaserLastName=this.purchaserLastName.trim()}catch{}
  try{this.purchaserFirstName=this.purchaserFirstName.trim()}catch{}
  try{this.purchaseEmail=this.purchaseEmail.trim()}catch{}
  try{this.purchaseEmailConfirm=this.purchaseEmailConfirm.trim()}catch{}
      if(this.NonResidentSelected==false){
      if(!this.purchaserLastName){flag=false;this.purchaserLastNameFlag=true}else{this.purchaserLastNameFlag=false}
      if(!this.purchaserFirstName){flag=false;this.purchaserFirstNameFlag=true}else{this.purchaserFirstNameFlag=false}
      // if(!this.purchaserAddress1){flag=false;this.purchaserAddress1Flag=true}else{flag=true;this.purchaserAddress1Flag=false}
      // if(!this.form4.purchaseLanguage.value){flag=false;this.purchaseLanguageFlag=true}else{flag=true;this.purchaseLanguageFlag=false}
      // if(!this.purchaseProvince){flag=false;this.purchaseProvinceFlag=true}else{flag=true;this.purchaseProvinceFlag=false}
      // if(!this.purchaseCity){flag=false;this.purchaseCityFlag=true}else{flag=true;this.purchaseCityFlag=false}
      // if(!this.purchasePostalCode){flag=false;this.purchasePostalCodeFlag=true}else{flag=true;this.purchasePostalCodeFlag=false}
    //  if(!this.purchasePhone1){flag=false;this.purchasePhone1Flag=true}else{this.purchasePhone1Flag=false}
      if(!this.purchaseEmail){flag=false;this.purchaseEmailFlag=true}else{this.purchaseEmailFlag=false}
     if(!this.purchaseEmailConfirm){flag=false;this.purchaseConfirmEmailFlag=true}else{this.purchaseConfirmEmailFlag=false}
    }
    else{
      if(!this.purchaserLastName){flag=false;this.purchaserLastNameFlag=true}else{this.purchaserLastNameFlag=false}
      if(!this.purchaserFirstName){flag=false;this.purchaserFirstNameFlag=true}else{this.purchaserFirstNameFlag=false}
      if(!this.purchaserAddress1){flag=false;this.purchaserAddress1Flag=true}else{this.purchaserAddress1Flag=false}
      // if(!this.form4.purchaseLanguage.value){flag=false;this.purchaseLanguageFlag=true}else{flag=true;this.purchaseLanguageFlag=false}
      if(!this.purchaseProvince){flag=false;this.purchaseProvinceFlag=true}else{this.purchaseProvinceFlag=false}
      if(!this.purchaseCity){flag=false;this.purchaseCityFlag=true}else{this.purchaseCityFlag=false}
      if(!this.purchasePostalCode){flag=false;this.purchasePostalCodeFlag=true}else{this.purchasePostalCodeFlag=false}
     if(!this.purchasePhone1){flag=false;this.purchasePhone1Flag=true}else{this.purchasePhone1Flag=false}
      if(!this.purchaseEmail){flag=false;this.purchaseEmailFlag=true}else{this.purchaseEmailFlag=false}
     if(!this.purchaseEmailConfirm){flag=false;this.purchaseConfirmEmailFlag=true}else{this.purchaseConfirmEmailFlag=false}
    }
      if (flag == true && this.confirmEmailMatch == false && this.purchasePhone1Flag == false && this.purchaseCityFlag ==false && this.purchaserAddress1Flag == false && this.purchaseConfirmEmailFlag ==false) {  
        this.showChangePolicy=true;
        this.showChangePolicyStepOne=false;
        this.showChangePolicyStepTwo=false;
        this.showChangePolicyStepTwoB=false;
        this.showChangePolicyStepThree=false;
        this.showChangePolicyStepThreeAdminFee=true;
        this.showChangePolicyStepFour=false;
        this.showChangePolicyStepFive=false;
        this.showSearchedPolicy=false;
        this.showPolicyDetails=false;
        this.showPolicySearch=false;
        this.showRefundPolicy=false;
        this.showAudtiLogs=false;  
      //   const request = 
      //   {      
      //     "agentId": this.agentId,
      //     "declaration": true,
      //     "policyId": this.policyId,
      //     "deductableOptions": [
      //       {
      //         "amount": 0,
      //         "createdAt": "",
      //         "createdBy": "",
      //         "id": 0,
      //         "lastModifiedBy": "",
      //         "option": "",
      //         "reduceAmount": 0,
      //         "updatedAt": ""
      //       }
      //     ],
      //     "language": this.selectedQuestionlanguages1,
      //     "noOfDays": this.calculatedDays,
      //     "optionalInformation": {
      //       "agentNote": this.comment,
      //       "beneficiary": this.beneficiary,
      //       "comment": this.agentNote
      //     },
      //     "paymentInformation": {
      //       "amount": 0,
      //       "cardNumber": "",
      //       "cardType": "",
      //       "cvv": "",
      //       "expiryDate": ""
      //     },
      //     "primaryAddress": {
      //       "address1": this.primaryAddress1,
      //       "address2": this.primaryAddress2,
      //       "city": this.primaryCity,
      //       "postalCode": this.primaryPostalCode,
      //       "province": this.primaryProvince
      //     },
      //     "purchaserAddressSame": true,
      //     "questionsansers": "",
      //     "residentOf": "",
      //     "returnDate": this.expiryDate,
      //     "secondaryAddress": {
      //       "address1": "",
      //       "address2": "",
      //       "city": "",
      //       "postalCode": "",
      //       "province":""
      //     },
      //     "selectedPlan": "",
      //     "startDate": this.startDate,
      //     "travellerInformation": this.travellerInfo,
      //     "travelllerDetails": this.insuredPersonArray,
      //     "visitorsToCanada": this.selectedQuestionAns1,
      //     "purchaserInformation":{
      //       "country": "",
      //       "emailAddress": this.purchaseEmail,
      //       "firstName": this.purchaserFirstName,
      //       "language": this.selectedQuestionlanguages1,
      //       "lastName": this.purchaserLastName,
      //       "phoneNumber1": this.purchasePhone1,
      //       "phoneNumber2": this.purchasePhone2,
      //       "postalCode": this.purchasePostalCode,
      //       "province": this.purchaseProvince,
      //       "purchaserAddress": {
      //         "address1": this.purchaserAddress1,
      //         "address2": this.purchaserAddress2,
      //         "city": this.purchaseCity,
      //         "postalCode": this.purchasePostalCode
      //     }}
      //    }
      //   // this.restService.callPostService(this.config.postApistep3, request).subscribe((data: any) => {
      // this.base.callPostService(this.config.postApistep3, request).subscribe((data: any) => {
      //   // window.scrollTo(0, 0);
      //   // this.showChangePolicy=true;
      //   // this.showChangePolicyStepOne=false;
      //   // this.showChangePolicyStepTwo=true;
      //   // this.showChangePolicyStepTwoB=false;
      //   // this.showChangePolicyStepThree=true;
      //   // this.showChangePolicyStepThreeAdminFee=false;
      //   // this.showChangePolicyStepFour=false;
      //   // this.showChangePolicyStepFive=false;
      //   // this.showSearchedPolicy=false;
      //   // this.showPolicyDetails=false;
      //   // this.showPolicySearch=false;
      //   // this.showRefundPolicy=false;
      // //this.step2SaveApiCall()
      // // if(this.intStudPlanChecked==true || this.intStudPlanChecked1==true){
      // //   this.showQuestionnaireQue=false;
      // //   this.showDeclarationQuestionnaire=false;
      // //   this.showChooseQuote=false;
      // //   this.showIntStudPlan=true;
      // //   this.showIntStudPlanStep1=false;
      // //   this.showIntStudPlanPlanOption=false;
      // //   this.showQuestionnaire=false;
      // //   this.showQuestionnaireQue=false;
      // //   this.showContactInfo=false;
      // //   this.showPayment=true;
      // //   this.showPaymentsDetails=false;
      // // }
      // // if(this.studAccidentIncChecked==true){
      // //   this.showQuestionnaireQue=false;
      // //   this.showDeclarationQuestionnaire=false;
      // //   this.showChooseQuote=false;
      // //   this.showIntStudPlan=true;
      // //   this.showIntStudPlanStep1=false;
      // //   this.showIntStudPlanPlanOption=false;
      // //   this.showQuestionnaire=false;
      // //   this.showQuestionnaireQue=false;
      // //   this.showContactInfo=false;
      // //   this.showPayment=true;
      // //   this.showPaymentsDetails=false;
      // // }
      // //this.paymentCall();
      // // this.step2SaveApiCall()
      //   // localStorage.removeItem('selectedQuestionprovince1');
      //   // localStorage.removeItem('selectedQuestionlanguages1');
      //   // setTimeout(() =>
      //   // {
      //   // this.finalStageTransactionCall();
      //   // },
      //   // 8000);
      //      }, error => {{
      //       if (error.status == 400) {
      //       }
      //     }
      //   }, () => { });
      } 
      
     }
     disableProvince: boolean=false;
     purchaserAddressSame: boolean=false;
     onClickAddressSameCheckbox(event){
    
      var testFlag =event.target.checked;
      
      if(testFlag){
        this.purchaserAddressSame= true;
        this.purchaserAddress1=this.primaryAddress1;
        this.purchaserAddress2=this.primaryAddress2;
        this.purchaseCity=this.primaryCity;
        this.purchasePostalCode=this.primaryPostalCode;
        this.purchaseProvince=this.primaryProvince;
        this.disableProvince = true;
      }else{
        this.purchaserAddressSame= false;
        this.purchaserAddress1="";
        this.purchaserAddress2="";
        this.purchaseCity="";
        // this.purchasePostalCode;
        // this.purchaseProvince="";
        this.disableProvince = false;
      }
      }
    purchaseConfirmEmailFlag: boolean=false;
    onConfirmEmailClick(){
      this.purchaseConfirmEmailFlag=false;  
      }
      
      
      paymentCall(){
        
        this.blockUI.start(); 
        // window.open("https://api.demo.convergepay.com/hosted-payments/?ssl_txn_auth_token="+this.paymentToken,'_self');
        // this.form4.expDateToSend.setValue(this.form4.expDate1ToSend.value+this.form4.expDateYearToSend.value)
        //this.loading=true;
        this.paymentToken;
        this.paymentTokenNew
        pay(this.paymentToken,this.paymentTokenNew,this.ssl_exp_date1,this.purchaserFirstName,this.purchaserLastName,this.ssl_avs_address,this.ssl_avs_zip);
        window.scroll(0,0)
        // openLightbox(this.paymentToken);
        }
        isDisabled: boolean = false;
        goToQuotePurchase(){
          if(this.isDisabled){
            return;
          }
          if(this.hideQuotePurchase!="true"){
            this.router.navigateByUrl('/dashboard/Quotes-Purchase');
          }else{
            Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
          }
        }
        CCExpdate1(){
        
          var re=/(0[1-9]|1[0-2])\/?([0-9]{2})$/mg
          if(!re.test(this.cardexpdate1)){
            this.cardexpdate1Flag=true
          }else{
            this.cardexpdate1Flag=false;
         
          this.cardexpdate1Flag=false
          this.cardexpdateFlagButtonDisable=false
          
            
        if(this.cardexpdate1.charAt(2) === '/'){
          this.expDate1ToSend=this.cardexpdate1.substring(0, 2);
          this.expDateYearToSend=this.cardexpdate1.substring(3, 5)
        }
        else{
        
        this.expDate1ToSend=this.cardexpdate1.substring(0, 2);
        this.expDateYearToSend=this.cardexpdate1.substring(2, 4)
      }
        const d = new Date();
        let month = getMonth(d);
        function getMonth(date) {
          var month = date.getMonth() + 1;
          return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
        }  
        
        const last2 = new Date().getFullYear().toString().slice(-2);
        console.log(last2); // 👉️ has type of string
        const last2Num = Number(last2);
        
          console.log(month)
          console.log(last2Num)
          console.log(this.expDate1ToSend)
          console.log(this.expDateYearToSend)
          if(this.expDateYearToSend<last2Num)
          {
            this.cardexpdate1Flag=true
            this.cardexpdateFlagButtonDisable=true
          }
          else{
            this.cardexpdate1Flag=false
        this.cardexpdateFlagButtonDisable=false
        if(this.expDate1ToSend<month && this.expDateYearToSend<=last2Num)
        {
         
          this.cardexpdate1Flag=true
          this.cardexpdateFlagButtonDisable=true
        }
        
      }
          if(this.cardType1=='VISA' || this.cardType1=='MasterCard' || this.cardType1=='AmericanExpress'){
            this.showCardNo1=true;
          }else{
            this.showCardNo1=false;
          }
          this.showCVV1=false
          this.showexp1=true
        }
        }
        CCExpdate2(){
          var re=/(0[1-9]|1[0-2])\/?([0-9]{2})$/mg
          if(!re.test(this.cardexpdate2)){
            this.cardexpdate2Flag=true
          }else{
           
          this.cardexpdate2Flag=false
          this.cardexpdateFlagButtonDisable=false
         
        if(this.cardexpdate2.charAt(2) === '/'){
          this.expDate1ToSend=this.cardexpdate2.substring(0, 2);
          this.expDateYearToSend=this.cardexpdate2.substring(3, 5)
        }
        else{
        
        this.expDate1ToSend=this.cardexpdate2.substring(0, 2);
        this.expDateYearToSend=this.cardexpdate2.substring(2, 4)
      }
       
        const d = new Date();
        let month = getMonth(d);
        function getMonth(date) {
          var month = date.getMonth() + 1;
          return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
        }  
        
        const last2 = new Date().getFullYear().toString().slice(-2);
        console.log(last2); // 👉️ has type of string
        const last2Num = Number(last2);
        
          console.log(month)
          console.log(last2Num)
          console.log(this.expDate1ToSend)
          console.log(this.expDateYearToSend)
          if(this.expDateYearToSend<last2Num)
          {
            this.cardexpdate2Flag=true
            this.cardexpdateFlagButtonDisable=true
          }
          else{
            this.cardexpdate2Flag=false
        this.cardexpdateFlagButtonDisable=false
        if(this.expDate1ToSend<month && this.expDateYearToSend<=last2Num)
        {
         
          this.cardexpdate2Flag=true
          this.cardexpdateFlagButtonDisable=true
        }
        
      }
      
          if(this.cardType2=='VISA' || this.cardType2=='MasterCard' || this.cardType2=='AmericanExpress'){
            this.showCardNo2=true;
          }else{
            this.showCardNo2=false;
          }
          this.showCVV2=false
          this.showexp2=true
        }
          
        }
        CCExpdate3(){
          var re=/(0[1-9]|1[0-2])\/?([0-9]{2})$/mg
          if(!re.test(this.cardexpdate3)){
            this.cardexpdate3Flag=true
          }else{
            this.cardexpdate3Flag=false
          this.cardexpdate3Flag=false
          this.cardexpdateFlagButtonDisable=false
          
          if(this.cardexpdate3.charAt(2) === '/'){
            this.expDate1ToSend=this.cardexpdate3.substring(0, 2);
            this.expDateYearToSend=this.cardexpdate3.substring(3, 5)
          }
          else{
          
          this.expDate1ToSend=this.cardexpdate3.substring(0, 2);
          this.expDateYearToSend=this.cardexpdate3.substring(2, 4)
        }
       
        const d = new Date();
        let month = getMonth(d);
        function getMonth(date) {
          var month = date.getMonth() + 1;
          return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
        }  
        
        const last2 = new Date().getFullYear().toString().slice(-2);
        console.log(last2); // 👉️ has type of string
        const last2Num = Number(last2);
        
          console.log(month)
          console.log(last2Num)
          console.log(this.expDate1ToSend)
          console.log(this.expDateYearToSend)
          if(this.expDateYearToSend<last2Num)
          {
            this.cardexpdate3Flag=true
            this.cardexpdateFlagButtonDisable=true
          }
          else{
            this.cardexpdate3Flag=false
            this.cardexpdateFlagButtonDisable=false
        if(this.expDate1ToSend<month && this.expDateYearToSend<=last2Num)
        {
         
          this.cardexpdate3Flag=true
          this.cardexpdateFlagButtonDisable=true
        }
       
      }
      
          if(this.cardType3=='VISA' || this.cardType3=='MasterCard' || this.cardType3=='AmericanExpress'){
            this.showCardNo3=true;
          }else{
            this.showCardNo3=false;
          }
          this.showCVV3=false
          this.showexp3=true
        }
          
        }
        CCExpdate4(){
           var re=/(0[1-9]|1[0-2])\/?([0-9]{2})$/mg
          if(!re.test(this.cardexpdate4)){
            this.cardexpdate4Flag=true
          }else{
            
          this.cardexpdate4Flag=false
          this.cardexpdateFlagButtonDisable=false
          if(this.cardexpdate4.charAt(2) === '/'){
            this.expDate1ToSend=this.cardexpdate4.substring(0, 2);
            this.expDateYearToSend=this.cardexpdate4.substring(3, 5)
          }
        
        else{
        
        this.expDate1ToSend=this.cardexpdate4.substring(0, 2);
        this.expDateYearToSend=this.cardexpdate4.substring(2, 4)
      }
        
        
             
        const d = new Date();
        let month = getMonth(d);
        function getMonth(date) {
          var month = date.getMonth() + 1;
          return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
        }  
        
        const last2 = new Date().getFullYear().toString().slice(-2);
        console.log(last2); // 👉️ has type of string
        const last2Num = Number(last2);
        
          console.log(month)
          console.log(last2Num)
          console.log(this.expDate1ToSend)
          console.log(this.expDateYearToSend)
          if(this.expDateYearToSend<last2Num)
          {
            this.cardexpdate4Flag=true
            this.cardexpdateFlagButtonDisable=true
          }
          else{
            this.cardexpdate4Flag=false
        this.cardexpdateFlagButtonDisable=false
        if(this.expDate1ToSend<month && this.expDateYearToSend<=last2Num)
        {
         
          this.cardexpdate4Flag=true
          this.cardexpdateFlagButtonDisable=true
        }
        
      }
      
          if(this.cardType4=='VISA' || this.cardType4=='MasterCard' || this.cardType4=='AmericanExpress'){
            this.showCardNo4=true;
          }else{
            this.showCardNo4=false;
          }
          this.showCVV4=false
          this.showexp4=true
          
        }
        }
        CCExpdate5(){
          var re=/(0[1-9]|1[0-2])\/?([0-9]{2})$/mg
          if(!re.test(this.cardexpdate5)){
            this.cardexpdate5Flag=true
          }else{
          this.cardexpdate5Flag=false
          this.cardexpdateFlagButtonDisable=false
          
          if(this.cardexpdate5.charAt(2) === '/'){
            this.expDate1ToSend=this.cardexpdate5.substring(0, 2);
            this.expDateYearToSend=this.cardexpdate5.substring(3, 5)
          }
        
        else{
        
        this.expDate1ToSend=this.cardexpdate5.substring(0, 2);
        this.expDateYearToSend=this.cardexpdate5.substring(2, 4)
      }
        const d = new Date();
        let month = getMonth(d);
        function getMonth(date) {
          var month = date.getMonth() + 1;
          return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
        }  
        
        const last2 = new Date().getFullYear().toString().slice(-2);
        console.log(last2); // 👉️ has type of string
        const last2Num = Number(last2);
        
          console.log(month)
          console.log(last2Num)
          console.log(this.expDate1ToSend)
          console.log(this.expDateYearToSend)
          if(this.expDateYearToSend<last2Num)
          {
            this.cardexpdate5Flag=true
            this.cardexpdateFlagButtonDisable=true
          }
          else{
            this.cardexpdate5Flag=false
        this.cardexpdateFlagButtonDisable=false
        if(this.expDate1ToSend<month && this.expDateYearToSend<=last2Num)
        {
         
          this.cardexpdate5Flag=true
          this.cardexpdateFlagButtonDisable=true
        }
        
      }
      
      if(this.cardType5=='VISA' || this.cardType5=='MasterCard' || this.cardType5=='AmericanExpress'){
        this.showCardNo5=true;
      }else{
        this.showCardNo5=false;
      }
      this.showCardNo5=false
      this.showCVV5=false
    }
          
        }
        getLeadAgentsCodes(){
          this.user.getLeadAgentsCodes(this.leadsId).pipe()
          .subscribe(
            data => {
            // console.log(data);
            // this.agentcodedata=[];
          ////debugger
            // this.agentIdActive=sessionStorage.getItem('agentIdActive');
            for(let i=0;i<data.data.agentCodes.length;i++){
              if(this.agentId==data.data.agentCodes[i].id){
                if(data.data.agentCodes[i].status=="Active" || data.data.agentCodes[i].status=="Primary")
                {
                this.agentIdActive='true'
                }
                else{
                  this.agentIdActive='false'
                }
              }
             // this.agentcodedata.push(data.data.agentCodes[i])
              // console.log(this.agentcodedata)
            }
            }, error => {
        
              // if (error.status == 400 || error.status == 417) {
              //   this.error = error.error.data;
              // }
              // else {
              //   this.error = "Something went wrong. Please check username and password.";
              // }
            }, () => { });
          }
          goToSalesHome(){
            if(this.agentIdActive=='true'){
              this.router.navigateByUrl('/dashboard/sales-home');
            }else{
              // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
            }
      
          }
      goToPolicySearch(){
        if(this.agentIdActive=='true'){
          this.router.navigateByUrl('/dashboard/policy-search');
        }else{
          // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
        }
      
      }
      goToSaveQuote(){
        
        if(this.agentIdActive=='true'){
          this.router.navigateByUrl('/dashboard/Save-Quotes');
        }else{
          // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
        }
      }
      goToforms(){
        
        if(this.agentIdActive=='true'){
          this.router.navigateByUrl('/dashboard/forms');
        }else{
          // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
        }
      }
      goToResources(){
        if(this.agentIdActive=='true'){
          this.router.navigateByUrl('/dashboard/resources');
        }else{
          // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
        }
      
      }
      getDashboard() {
        this.user.getDashboardData().pipe()
          .subscribe(
            data => {
              this.leadStatus=data.data.leads.leadStatus;
              if(this.leadStatus == 'Deactivated'){
                this.isDisabled = true;
              } else{
                this.isDisabled = false;
              }
             }, error => {
            }, () => { });
      }
  }